import { MdOutlineAddToHomeScreen, MdOutlineSpaceDashboard } from "react-icons/md";
import { LuPencilLine } from "react-icons/lu";
import DefaultAvatarIcon from '../assets/avataricon.jpg';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { gsap } from 'gsap';
import LogoWhite from '../assets/LOGO_WHITE.png';
import LeftSwipe from '../assets/leftinward-swipe.png';
import UpSwipe from '../assets/upinward-swipe.png';
// Firebase imports for profile system
import { 
  getAuth, 
  onAuthStateChanged, 
  updateProfile, 
  updateEmail, 
  updatePassword, 
  EmailAuthProvider, 
  reauthenticateWithCredential,
  signOut 
} from 'firebase/auth';
import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { getStorage, ref, uploadString, getDownloadURL } from 'firebase/storage';

// For Homepage Background
const BG_01 = "https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/ui_images_backgrounds%2FBG_01.jpg?alt=media&token=9e891581-27bf-4bdd-83cf-a39b44af9324";
const BG_02 = "https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/ui_images_backgrounds%2FBG_02.jpg?alt=media&token=b4394dc2-756e-41e8-9cfd-53c25137835d";
const BG_03 = "https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/ui_images_backgrounds%2FBG_03.jpg?alt=media&token=989909db-898b-4f93-babf-0262e968ddff";
const BG_04 = "https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/ui_images_backgrounds%2FBG_04.jpg?alt=media&token=b895a70e-d345-48b9-aa06-a359057f059a";
const BG_05 = "https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/ui_images_backgrounds%2FBG_05.jpg?alt=media&token=d91d94d3-064a-4efa-8bcf-f37cd4a04714";

// Updated 3D Model URLs from Firebase Storage
const MODEL_BELINI = "https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/assets%2F3D_Models%2Fbelinidraco.glb?alt=media&token=c5c11b01-989e-46be-9cdd-15ac2a2ff0a9";
const MODEL_SOFA = "https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/assets%2F3D_Models%2Fsofa2draco.glb?alt=media&token=1c91cecc-f089-44df-bd7c-6adb9100313d";

// Preload images
const preloadedImages = [BG_01, BG_02, BG_03, BG_04, BG_05].map(src => {
  const img = new Image();
  img.src = src;
  return img;
});

// Popup style constants for light-mode popups
const popupOverlayStyle = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 200,
  display: 'flex', alignItems: 'center', justifyContent: 'center'
};
const popupContentStyle = {
  backgroundColor: '#FAFAFA', borderRadius: '16px', padding: '25px',
  maxWidth: '400px', width: '70%', boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
};
const popupInputStyle = {
  width: '100%', padding: '12px 16px', marginBottom: '15px',
  backgroundColor: '#FFFFFF', border: '1px solid #DDDDDD', borderRadius: '8px',
  fontSize: '1rem', fontFamily: 'avenir-lt-pro, sans-serif', boxSizing: 'border-box'
};
const popupCancelStyle = {
  padding: '10px 20px', backgroundColor: '#636262ff', border: 'none',
  borderRadius: '30px', cursor: 'pointer', fontFamily: 'avenir-lt-pro, sans-serif'
};
const popupConfirmStyle = {
  padding: '10px 20px', backgroundColor: '#88B7FF', border: 'none',
  borderRadius: '30px', color: 'white', cursor: 'pointer', fontFamily: 'avenir-lt-pro, sans-serif'
};

export default function Home() {
  // Page Title
  useEffect(() => {
    document.title = "Outlne | Modern Interior Designing For Any Project | Create Endlessly";
  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  
    const handleAuthClick = useCallback((mode = 'signup') => {
    const width = 500;
    const height = 600;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    
    const popup = window.open(
      `/auth?mode=${mode}`,
      'authPopup',
      `width=${width},height=${height},left=${left},top=${top},resizable=no,scrollbars=no,toolbar=no,menubar=no,location=no,status=no`
    );
    
    if (popup) {
      popup.focus();
    }
  }, []);

  const [inputValue, setInputValue] = useState('');
  const [showError, setShowError] = useState(false);
  const inputRef = useRef(null);

    const handleGenerateClick = useCallback(() => {
    if (!inputValue.trim()) {
      setShowError(true);
      if (inputRef.current) {
        inputRef.current.focus();
      }
      return;
    }
    
    setShowError(false);
    handleAuthClick('signup');
  }, [inputValue, handleAuthClick]);

  // For Add to Homescreen Overlay
  const [showA2HSOverlay, setShowA2HSOverlay] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    
    if (isLeftSwipe && currentStep < 2) {
      setCurrentStep(prev => prev + 1);
    }
    
    if (isRightSwipe && currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
    
    setTouchStart(null);
    setTouchEnd(null);
  };

  const [showShareButton, setShowShareButton] = useState(false);
  const [showMobileMainContent, setShowMobileMainContent] = useState(true);

  const handleNativeShare = useCallback(async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title || 'Outlne - Interior Design Editor',
          text: 'Create beautiful interior designs with Outlne',
          url: window.location.href,
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.log('Error sharing:', error);
          alert('Please tap the share button at the bottom of Safari and look for "Add to Home Screen"');
        }
      }
    } else {
      alert('Please tap the share button at the bottom of Safari and look for "Add to Home Screen"');
    }
  }, []);

  const handleOpenA2HS = useCallback(() => {
    setShowMobileMainContent(false);
    setShowA2HSOverlay(true);
  }, []);

  const handleCloseA2HS = useCallback(() => {
    const overlay = document.querySelector('.a2hs-overlay');
    
    setCurrentStep(0);
    
    if (overlay) {
      overlay.style.animation = 'fadeOutOverlay 0.3s ease-out forwards';
      setShowA2HSOverlay(false);
      setShowMobileMainContent(true);
    } else {
      setShowA2HSOverlay(false);
      setShowMobileMainContent(true);
    }
  }, []);

  useEffect(() => {
    setShowShareButton(currentStep === 3);
  }, [currentStep]);

  const [isStandalone, setIsStandalone] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeGrid, setActiveGrid] = useState(0);
  const gridScrollRef = useRef({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(false);
  const [verticalOffset, setVerticalOffset] = useState(0);
  const [horizontalOffset, setHorizontalOffset] = useState(0);
  const [isBottomRevealed, setIsBottomRevealed] = useState(false);
  const [isRightRevealed, setIsRightRevealed] = useState(false);
  const [typedText, setTypedText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const [bgIndex, setBgIndex] = useState(0);
  const [bgPosition, setBgPosition] = useState({ x: 0, y: 0 });
  const [bgScale, setBgScale] = useState(1);
  const [bgOpacity, setBgOpacity] = useState(0);
  const [currentSubtext, setCurrentSubtext] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuItemsVisible, setMenuItemsVisible] = useState([false, false, false, false]);
  const [showBottomMenu, setShowBottomMenu] = useState(true);
  const [isFunModeActive, setIsFunModeActive] = useState(false);
  const [scrollTriggerActive, setScrollTriggerActive] = useState(false);
  const [modelLoading, setModelLoading] = useState(false);
  const [modelProgress, setModelProgress] = useState(0);
  const [gridOpacity, setGridOpacity] = useState(1);
  const [currentModelIndex, setCurrentModelIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  
  // Profile System State Variables
  const [showProfileCard, setShowProfileCard] = useState(false);
  const [authUser, setAuthUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isProfileLoading, setIsProfileLoading] = useState(true);
  
  // Avatar Editing State
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [isSavingAvatar, setIsSavingAvatar] = useState(false);
  
  // Email Change Popup State
  const [showEmailChangePopup, setShowEmailChangePopup] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [emailPassword, setEmailPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [emailSuccess, setEmailSuccess] = useState('');
  
  // Password Change Popup State
  const [showPasswordChangePopup, setShowPasswordChangePopup] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  
  // Delete Disclaimer Popup State
  const [showDeleteDisclaimer, setShowDeleteDisclaimer] = useState(false);
  
  // User Name Editing State
  const [userName, setUserName] = useState('User');
  const [userAvatar, setUserAvatar] = useState(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [tempUserName, setTempUserName] = useState('');
  const profileFileInputRef = useRef(null);
  
  const lastGridChangeTime = useRef(0);
  const touchStartY = useRef(0);
  const touchStartX = useRef(0);
  const isDragging = useRef(false);
  const containerRef = useRef(null);
  const typewriterRef = useRef(null);
  const bgIntervalRef = useRef(null);
  const bgAnimationRef = useRef(null);
  const subtextIntervalRef = useRef(null);
  const cursorIntervalRef = useRef(null);
  const textRotationIntervalRef = useRef(null);
  const menuAnimationRef = useRef(null);
  const scrollTriggerRef = useRef(null);
  const scrollTimeoutRef = useRef(null);
  const threeMountRef = useRef(null);
  const modelCache = useRef([]);
  const modelRotationInterval = useRef(null);
  const currentModelRef = useRef(null);
  const sceneRef = useRef(null);
  const rendererRef = useRef(null);
  const controlsRef = useRef(null);
  const cameraRef = useRef(null);
  const modelOpacityRef = useRef(0);
  const rafRef = useRef(null);
  const resizeTimeoutRef = useRef(null);
  const gridAnimationRef = useRef(null);
  const prevAuthUser = useRef(null);
  const hasRedirectedRef = useRef(false);
  const didRedirect = useRef(false);
  const initialCheckDone = useRef(false);
  const modelSettings = {
    0: {
      minDistance: 425,
      maxDistance: 445,
      scale: 1.5,
      cameraPosition: { x: 0, y: 10, z: 35 },
      targetOffset: { x: 0, y: -5, z: 0 }
    },
    1: {
      minDistance: 2800,
      maxDistance: 2820,
      scale: 0.3,
      cameraPosition: { x: 0, y: 752, z: 40 },
      targetOffset: { x: 0, y: -343, z: 0 }
    },
    2: {
      minDistance: 425,
      maxDistance: 445,
      scale: 1.5,
      cameraPosition: { x: 0, y: 10, z: 35 },
      targetOffset: { x: 0, y: -5, z: 0 }
    },
    3: {
      minDistance: 425,
      maxDistance: 445,
      scale: 1.5,
      cameraPosition: { x: 0, y: 10, z: 35 },
      targetOffset: { x: 0, y: -5, z: 0 }
    }
  };

  const backgrounds = useMemo(() => [BG_01, BG_02, BG_03, BG_04, BG_05], []);
  
  const modelUrls = useMemo(() => [
    MODEL_BELINI,
    MODEL_SOFA,
    MODEL_BELINI,
    MODEL_BELINI
  ], []);
  
    const typewriterLines = [
    "What will",
    "you design? "
  ];
  const textVariations = [
    "create?",
    "build?",
    "design?"
  ];
  const subtextOptions = [
    "a beautiful room",
    "switching out my sofa",
    "a floor remodel",
    "inspo for a client"
  ];
  const menuItems = [
    { name: "Dashboard", path: "/dashboard", disabled: true },
    { name: "Pricing", path: "/pricing" },
    { name: "Features", path: "/features" },
    { name: "Support", path: "/support" }
  ];

  const [mobileScale, setMobileScale] = useState(1);
    // Cleanup effect to stop animations on unmount (speeds up navigation)
  useEffect(() => {
    return () => {
      // Immediately stop all animations
      if (gridAnimationRef.current) {
        cancelAnimationFrame(gridAnimationRef.current);
      }
      if (bgIntervalRef.current) {
        clearInterval(bgIntervalRef.current);
      }
      if (subtextIntervalRef.current) {
        clearInterval(subtextIntervalRef.current);
      }
      if (typewriterRef.current) {
        clearTimeout(typewriterRef.current);
      }
      if (cursorIntervalRef.current) {
        clearInterval(cursorIntervalRef.current);
      }
      if (modelRotationInterval.current) {
        clearInterval(modelRotationInterval.current);
      }
      
      // Kill all GSAP animations
      gsap.killTweensOf("*");
    };
  }, []);

    // Helper Functions for Profile System
  const getDisplayName = useCallback(() => {
    if (!authUser) return 'Guest';
    if (userData?.displayName) return userData.displayName;
    if (userData?.firstName) return userData.firstName;
    return authUser.email?.split('@')[0] || 'User';
  }, [authUser, userData]);

    // Generate letter avatar as data URL
  const getLetterAvatar = useCallback(() => {
    const name = getDisplayName();
    if (!name || name === 'Guest') return DefaultAvatarIcon;
    
    // Get initials: 1 letter for nickname, 2 letters for full name
    let initials;
    const nameParts = name.split(' ');
    if (userData?.displayName) {
      initials = name.charAt(0).toUpperCase();
    } else if (nameParts.length >= 2) {
      initials = (nameParts[0][0] + nameParts[1][0]).toUpperCase();
    } else {
      initials = name.charAt(0).toUpperCase();
    }
    
    // Create canvas
    const canvas = document.createElement('canvas');
    canvas.width = 200;
    canvas.height = 200;
    const ctx = canvas.getContext('2d');
    
    // Clip to circle
    ctx.beginPath();
    ctx.arc(100, 100, 100, 0, Math.PI * 2);
    ctx.clip();
    
    // Grey background
    ctx.fillStyle = '#538ff0ff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // Grid lines
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
    ctx.lineWidth = 1;
    const gridSize = 40;
    for (let x = 0; x <= canvas.width; x += gridSize) {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, canvas.height);
      ctx.stroke();
    }
    for (let y = 0; y <= canvas.height; y += gridSize) {
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(canvas.width, y);
      ctx.stroke();
    }
    
    // White text
    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold 40px avenir-lt-pro, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(initials, canvas.width / 2, canvas.height / 2);
    
    return canvas.toDataURL();
  }, [getDisplayName, userData]);

  const getAvatarUrl = useCallback(() => {
    if (avatarPreview) return avatarPreview;
    if (userData?.photoURL) return userData.photoURL;
    if (authUser?.photoURL) return authUser.photoURL;
    if (authUser) return getLetterAvatar(); // Logged in but no photo = letter avatar
    return DefaultAvatarIcon; // Guest = default PNG
  }, [avatarPreview, userData, authUser, getLetterAvatar]);

  // Navigation handler for menu items
  const handleMenuNavigation = useCallback((path, disabled) => {
    if (!disabled) {
      if (window.opener) {
        window.opener.location.href = path;
        window.close();
      } else {
        navigate(path);
      }
    }
  }, [navigate]);

  // Handle Dashboard navigation
  const handleDashboardClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!authUser) {
      alert('Please log in to access the dashboard');
      return;
    }
    if (window.opener) {
      window.opener.location.href = '/dashboard';
      window.close();
    } else {
      navigate('/dashboard');
    }
  }, [authUser, navigate]);

// Auth State Listener
useEffect(() => {
    const auth = getAuth();
    
    // Check if user was just authenticated (came from popup)
    const checkIfFreshLogin = () => {
      // Check sessionStorage for a flag set by the auth popup
      const justLoggedIn = sessionStorage.getItem('justLoggedIn');
      if (justLoggedIn === 'true') {
        sessionStorage.removeItem('justLoggedIn');
        return true;
      }
      return false;
    };
    
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setAuthUser(user);
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid);
          const userDoc = await getDoc(userRef);
          
          // Check if this is a fresh login
          const isFreshLogin = checkIfFreshLogin();
          
          if (userDoc.exists()) {
            const data = userDoc.data();
            setUserData(data);
            if (data.displayName) {
              setUserName(data.displayName);
              setTempUserName(data.displayName);
            } else {
              const defaultName = user.email?.split('@')[0] || 'User';
              setUserName(defaultName);
              setTempUserName(defaultName);
            }
            if (data.photoURL) {
              setUserAvatar(data.photoURL);
            }
            
            // NAVIGATE TO DASHBOARD only on initial login/signup
            if (isFreshLogin && !didRedirect.current && data.profileComplete && 
                (data.subscriptionStatus === 'active' || data.subscriptionStatus === 'trialing')) {
              didRedirect.current = true;
              // Use setTimeout to ensure navigation happens after state updates
              setTimeout(() => {
                navigate('/dashboard');
              }, 100);
            }
          } else {
            const defaultName = user.email?.split('@')[0] || 'User';
            const basicData = {
              uid: user.uid,
              email: user.email,
              displayName: user.displayName || defaultName,
              photoURL: user.photoURL || null,
              createdAt: serverTimestamp(),
              profileComplete: false,
            };
            await setDoc(userRef, basicData);
            setUserData(basicData);
            setUserName(defaultName);
            setTempUserName(defaultName);
            if (user.photoURL) setUserAvatar(user.photoURL);
            
            // For new users, redirect to dashboard if they just signed up
            if (isFreshLogin && !didRedirect.current) {
              didRedirect.current = true;
              setTimeout(() => {
                navigate('/dashboard');
              }, 100);
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        // User signed out - reset the redirect flag
        didRedirect.current = false;
        setUserData(null);
        setUserName('Guest');
        setTempUserName('Guest');
        setUserAvatar(null);
      }
      setIsProfileLoading(false);
      initialCheckDone.current = true;
    });
    return () => unsubscribe();
  }, []);

  // Update menu items based on auth state
  const updatedMenuItems = useMemo(() => {
    return menuItems.map(item => {
      if (item.name === "Dashboard") {
        return { ...item, disabled: !authUser };
      }
      return item;
    });
  }, [authUser]);

  // Profile Card Handlers
  const handleCloseProfileCard = useCallback(() => {
    setShowProfileCard(false);
  }, []);

  const openProfileFromMobileMenu = useCallback(() => {
    closeReveals();
    setShowProfileCard(true);
  }, []);

  // Avatar Edit Handlers - WITH FILE VALIDATION
  const handleAvatarChange = useCallback((e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Image must be less than 5MB');
        return;
      }
      
      // Check file type
      if (!file.type.startsWith('image/')) {
        alert('Please select an image file');
        return;
      }
      
      setAvatarFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setAvatarPreview(reader.result);
      reader.readAsDataURL(file);
    }
  }, []);

    const handleSaveAvatar = useCallback(async () => {
    if (!avatarFile || !authUser) {
      console.log('No avatar file or user not logged in');
      return;
    }
    
    setIsSavingAvatar(true);
    console.log('Starting avatar save process...');
    
    try {
      // Compress image helper
      const compressImage = (dataUrl, maxWidth, maxHeight, quality) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            let width = img.width;
            let height = img.height;
            if (width > maxWidth) { height = (maxWidth / width) * height; width = maxWidth; }
            if (height > maxHeight) { width = (maxHeight / height) * width; height = maxHeight; }
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL('image/jpeg', quality));
          };
          img.src = dataUrl;
        });
      };
      
      // Compress to 400x400 at 85% quality
      const compressedPhoto = await compressImage(avatarPreview, 400, 400, 0.85);
      console.log('Compressed photo size:', Math.round(compressedPhoto.length / 1024), 'KB');
      
      // Upload to Firebase Storage
      const storage = getStorage();
      const storageRef = ref(storage, `avatars/user-profiles/${authUser.uid}.jpg`);
      await uploadString(storageRef, compressedPhoto, 'data_url');
      console.log('Uploaded to Storage');
      
      // Get download URL
      const downloadURL = await getDownloadURL(storageRef);
      console.log('Download URL obtained');
      
      // Update Firebase Auth profile
      await updateProfile(authUser, { photoURL: downloadURL });
      console.log('Auth profile updated');
      
      // Update Firestore
      const userRef = doc(db, 'users', authUser.uid);
      await updateDoc(userRef, { 
        photoURL: downloadURL,
        updatedAt: serverTimestamp() 
      });
      console.log('Firestore updated');
      
      // Update local state
      setUserData(prev => ({ ...prev, photoURL: downloadURL }));
      setUserAvatar(downloadURL);
      setAvatarFile(null);
      setAvatarPreview(null);
      
      console.log('Avatar saved successfully');
    } catch (error) {
      console.error("Avatar update error:", error);
      if (error.code === 'storage/unauthorized') {
        alert("Permission denied. Check Firebase Storage rules.");
      } else {
        alert("Failed to update avatar. Please try again.");
      }
    } finally {
      setIsSavingAvatar(false);
    }
  }, [avatarFile, avatarPreview, authUser]);

  const handleCancelAvatar = useCallback(() => {
    setAvatarFile(null);
    setAvatarPreview(null);
  }, []);

  // Email Change Handler
  const handleChangeEmail = useCallback(async (e) => {
    e.preventDefault();
    setEmailError('');
    setEmailSuccess('');
    if (!newEmail || !emailPassword) {
      setEmailError('All fields are required.');
      return;
    }
    try {
      const credential = EmailAuthProvider.credential(authUser.email, emailPassword);
      await reauthenticateWithCredential(authUser, credential);
      await updateEmail(authUser, newEmail);
      const userRef = doc(db, 'users', authUser.uid);
      await updateDoc(userRef, { email: newEmail, updatedAt: serverTimestamp() });
      setUserData(prev => ({ ...prev, email: newEmail }));
      setEmailSuccess('Email updated successfully!');
      setTimeout(() => {
        setShowEmailChangePopup(false);
        setNewEmail('');
        setEmailPassword('');
        setEmailSuccess('');
      }, 1500);
    } catch (error) {
      console.error("Email change error:", error);
      if (error.code === 'auth/wrong-password') setEmailError('Incorrect password.');
      else if (error.code === 'auth/email-already-in-use') setEmailError('This email is already in use.');
      else if (error.code === 'auth/invalid-email') setEmailError('Please enter a valid email address.');
      else if (error.code === 'auth/requires-recent-login') setEmailError('Please log out and log in again to change your email.');
      else setEmailError(error.message);
    }
  }, [authUser, newEmail, emailPassword]);

  // Password Change Handler
  const handleChangePassword = useCallback(async (e) => {
    e.preventDefault();
    setPasswordError('');
    setPasswordSuccess('');
    if (!oldPassword || !newPassword || !confirmNewPassword) {
      setPasswordError('All fields are required.');
      return;
    }
    if (newPassword !== confirmNewPassword) {
      setPasswordError('New passwords do not match.');
      return;
    }
    if (newPassword.length < 6) {
      setPasswordError('Password must be at least 6 characters.');
      return;
    }
    try {
      const credential = EmailAuthProvider.credential(authUser.email, oldPassword);
      await reauthenticateWithCredential(authUser, credential);
      await updatePassword(authUser, newPassword);
      setPasswordSuccess('Password updated successfully!');
      setTimeout(() => {
        setShowPasswordChangePopup(false);
        setOldPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
        setPasswordSuccess('');
      }, 1500);
    } catch (error) {
      console.error("Password change error:", error);
      if (error.code === 'auth/wrong-password') setPasswordError('Current password is incorrect.');
      else if (error.code === 'auth/weak-password') setPasswordError('Password should be at least 6 characters.');
      else if (error.code === 'auth/requires-recent-login') setPasswordError('Please log out and log in again to change your password.');
      else setPasswordError(error.message);
    }
  }, [authUser, oldPassword, newPassword, confirmNewPassword]);

  // Save Profile Name to Firebase
  const handleSaveProfileToFirebase = useCallback(async () => {
    if (!authUser) return;
    try {
      const userRef = doc(db, 'users', authUser.uid);
      await updateDoc(userRef, { 
        displayName: tempUserName, 
        updatedAt: serverTimestamp() 
      });
      await updateProfile(authUser, { displayName: tempUserName });
      setUserData(prev => ({ ...prev, displayName: tempUserName }));
      setUserName(tempUserName);
      setIsEditingName(false);
    } catch (error) {
      console.error("Profile update error:", error);
      alert("Failed to update profile. Please try again.");
    }
  }, [authUser, tempUserName]);

    // Sign Out Handler
      const handleSignOut = useCallback(async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
      setShowAvatarDropdown(false);
      setShowProfileCard(false);
      didRedirect.current = false; // Reset for next login
      console.log('User signed out successfully');
    } catch (error) {
      console.error("Sign out error:", error);
      setShowAvatarDropdown(false);
      setShowProfileCard(false);
      didRedirect.current = false;
    }
  }, []);

  // Mobile scale effect
  useEffect(() => {
    if (isMobile) {
      const checkViewport = () => {
        const viewportHeight = window.innerHeight;
        const screenHeight = window.screen.height;
        const hasSafariUI = viewportHeight < screenHeight * 0.85;
        setMobileScale(hasSafariUI ? 0.85 : 1);
      };

      checkViewport();
      window.addEventListener('resize', checkViewport);
      window.addEventListener('orientationchange', checkViewport);
      
      return () => {
        window.removeEventListener('resize', checkViewport);
        window.removeEventListener('orientationchange', checkViewport);
      };
    } else {
      setMobileScale(1);
    }
  }, [isMobile]);

  // Transform Mobile Scale to Accommodate Address Bar & Safari Buttons
  useEffect(() => {
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('orientationchange', setViewportHeight);

    return () => {
      window.removeEventListener('resize', setViewportHeight);
      window.removeEventListener('orientationchange', setViewportHeight);
    };
  }, []);

  const [safariUIVisible, setSafariUIVisible] = useState(false);

  // Check if app is in PWA Mode (Web App)
  useEffect(() => {
    const checkStandaloneMode = () => {
      const isStandaloneMediaQuery = window.matchMedia('(display-mode: standalone)').matches;
      const isIOSStandalone = ('standalone' in navigator) && navigator.standalone;
      const isNavigatorStandalone = window.navigator.standalone;
      const isPWALaunch = window.matchMedia('(display-mode: standalone)').matches || 
                         window.matchMedia('(display-mode: fullscreen)').matches ||
                         window.matchMedia('(display-mode: minimal-ui)').matches;
      
      const standaloneDetected = isStandaloneMediaQuery || 
                                isIOSStandalone || 
                                isNavigatorStandalone ||
                                isPWALaunch;
      
      setIsStandalone(standaloneDetected);
    };

    checkStandaloneMode();

    if (window.matchMedia) {
      const mediaQuery = window.matchMedia('(display-mode: standalone)');
      mediaQuery.addEventListener('change', checkStandaloneMode);
      return () => {
        mediaQuery.removeEventListener('change', checkStandaloneMode);
      };
    }
  }, []);

  // Preload all 3D models when component mounts
  useEffect(() => {
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');

    const loader = new GLTFLoader();
    loader.setDRACOLoader(dracoLoader);

    let loadedCount = 0;
    const totalModels = modelUrls.length;

    const checkAllModelsLoaded = () => {
      loadedCount++;
      if (loadedCount === totalModels) {
        setModelLoading(false);
      }
    };

    modelUrls.forEach((url, index) => {
      setModelLoading(true);
      loader.load(
        url,
        (gltf) => {
          modelCache.current[index] = gltf.scene;
          checkAllModelsLoaded();
        },
        (xhr) => {
          const percentLoaded = (xhr.loaded / xhr.total * 100);
          setModelProgress(percentLoaded);
        },
        (error) => {
          console.error(`Error loading model ${index}:`, error);
          checkAllModelsLoaded();
        }
      );
    });

    return () => {
      if (modelRotationInterval.current) {
        clearInterval(modelRotationInterval.current);
      }
    };
  }, [modelUrls]);

  // Handle Fun Mode transitions
  useEffect(() => {
    if (isFunModeActive) {
      setGridOpacity(0.1);
      
      modelOpacityRef.current = 0;
      
      gsap.to(modelOpacityRef, {
        current: 0.2,
        duration: 1,
        onUpdate: () => {
          if (currentModelRef.current) {
            currentModelRef.current.traverse((child) => {
              if (child.isMesh) {
                child.material.opacity = modelOpacityRef.current;
              }
            });
          }
        }
      });

      const timer = setTimeout(() => {
        setBgOpacity(0);
      }, 300);
      
      modelRotationInterval.current = setInterval(() => {
        gsap.to(modelOpacityRef, {
          current: 0,
          duration: 0.5,
          onUpdate: () => {
            if (currentModelRef.current) {
              currentModelRef.current.traverse((child) => {
                if (child.isMesh) {
                  child.material.opacity = modelOpacityRef.current;
                }
              });
            }
          },
          onComplete: () => {
            setCurrentModelIndex(prev => (prev + 1) % modelUrls.length);
          }
        });
      }, 8000);
      
      return () => {
        clearTimeout(timer);
        if (modelRotationInterval.current) {
          clearInterval(modelRotationInterval.current);
        }
      };
    } else {
      setGridOpacity(0.3);
      setBgOpacity(0.14);
      if (modelRotationInterval.current) {
        clearInterval(modelRotationInterval.current);
      }
    }
  }, [isFunModeActive, modelUrls.length]);

  // Initialize Three.js scene for Fun Mode
  useEffect(() => {
    if (!isFunModeActive) {
      if (rendererRef.current && threeMountRef.current) {
        threeMountRef.current.removeChild(rendererRef.current.domElement);
      }
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      return;
    }

    let animationFrameId;

    sceneRef.current = new THREE.Scene();
    sceneRef.current.background = null;

    cameraRef.current = new THREE.PerspectiveCamera(30, window.innerWidth / window.innerHeight, 0.1, 20000);
    cameraRef.current.position.set(0, 10, 35);

    rendererRef.current = new THREE.WebGLRenderer({ 
      antialias: true,
      alpha: true,
      powerPreference: "high-performance"
    });
    rendererRef.current.setSize(window.innerWidth, window.innerHeight);
    rendererRef.current.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    
    if (threeMountRef.current.children.length > 0) {
      threeMountRef.current.removeChild(threeMountRef.current.children[0]);
    }
    threeMountRef.current.appendChild(rendererRef.current.domElement);

    controlsRef.current = new OrbitControls(cameraRef.current, rendererRef.current.domElement);
    controlsRef.current.enableDamping = true;
    controlsRef.current.dampingFactor = 0.05;
    controlsRef.current.enableZoom = true;
    controlsRef.current.minDistance = modelSettings[0].minDistance;
    controlsRef.current.maxDistance = modelSettings[0].maxDistance;
    controlsRef.current.target.set(
      0,
      modelSettings[0].targetOffset.y,
      0
    );
    controlsRef.current.update();

    const createWireframeMaterial = () => {
      return new THREE.MeshBasicMaterial({
        color: new THREE.Color(0x40a3ff),
        wireframe: true,
        transparent: true,
        opacity: modelOpacityRef.current
      });
    };

    const loadModel = () => {
      if (modelCache.current[currentModelIndex]) {
        const model = modelCache.current[currentModelIndex].clone();
        currentModelRef.current = model;
        
        model.traverse((child) => {
          if (child.isMesh) {
            child.material = createWireframeMaterial();
          }
        });

        const box = new THREE.Box3().setFromObject(model);
        const center = box.getCenter(new THREE.Vector3());
        model.position.sub(center);
        
        model.scale.set(
          modelSettings[currentModelIndex].scale,
          modelSettings[currentModelIndex].scale,
          modelSettings[currentModelIndex].scale
        );

        sceneRef.current.add(model);

        cameraRef.current.position.set(
          modelSettings[currentModelIndex].cameraPosition.x,
          modelSettings[currentModelIndex].cameraPosition.y,
          modelSettings[currentModelIndex].cameraPosition.z
        );

        controlsRef.current.minDistance = modelSettings[currentModelIndex].minDistance;
        controlsRef.current.maxDistance = modelSettings[currentModelIndex].maxDistance;
        controlsRef.current.target.copy(center);
        controlsRef.current.target.y += modelSettings[currentModelIndex].targetOffset.y;
        controlsRef.current.update();

        gsap.to(cameraRef.current.position, {
          x: modelSettings[currentModelIndex].cameraPosition.x,
          y: modelSettings[currentModelIndex].cameraPosition.y,
          z: modelSettings[currentModelIndex].cameraPosition.z,
          duration: 1,
          onUpdate: () => {
            controlsRef.current.update();
          }
        });

        gsap.to(modelOpacityRef, {
          current: 0.2,
          duration: 1,
          onUpdate: () => {
            model.traverse((child) => {
              if (child.isMesh) {
                child.material.opacity = modelOpacityRef.current;
              }
            });
          }
        });
      }
    };

    const animate = () => {
      animationFrameId = requestAnimationFrame(animate);
      if (currentModelRef.current) {
        currentModelRef.current.rotation.y += 0.002;
      }
      controlsRef.current.update();
      rendererRef.current.render(sceneRef.current, cameraRef.current);
    };

    const handleResize = () => {
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
      
      resizeTimeoutRef.current = setTimeout(() => {
        cameraRef.current.aspect = window.innerWidth / window.innerHeight;
        cameraRef.current.updateProjectionMatrix();
        rendererRef.current.setSize(window.innerWidth, window.innerHeight);
      }, 250);
    };

    loadModel();
    rafRef.current = requestAnimationFrame(animate);
    window.addEventListener('resize', handleResize);

        return () => {
      window.removeEventListener('resize', handleResize);
      
      // Immediately stop render loop
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }
      
      // Force WebGL context loss and dispose renderer
      if (rendererRef.current) {
        rendererRef.current.forceContextLoss();
        rendererRef.current.dispose();
        
        // Remove DOM element
        if (threeMountRef.current && rendererRef.current.domElement) {
          if (threeMountRef.current.contains(rendererRef.current.domElement)) {
            threeMountRef.current.removeChild(rendererRef.current.domElement);
          }
        }
        rendererRef.current = null;
      }
      
      // Dispose controls
      if (controlsRef.current) {
        controlsRef.current.dispose();
        controlsRef.current = null;
      }
      
      // Clean up scene geometries and materials
      if (sceneRef.current) {
        sceneRef.current.traverse((child) => {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach(material => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        });
        sceneRef.current.clear();
        sceneRef.current = null;
      }
      
      // Dispose model cache
      modelCache.current.forEach(model => {
        if (model) {
          model.traverse((child) => {
            if (child.geometry) child.geometry.dispose();
            if (child.material) {
              if (Array.isArray(child.material)) {
                child.material.forEach(material => material.dispose());
              } else {
                child.material.dispose();
              }
            }
          });
        }
      });
      modelCache.current = [];
      
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
    };
  }, [isFunModeActive, currentModelIndex]);

  // Check screen size
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setShowBottomMenu(window.innerWidth > 900);
      setWindowWidth(window.innerWidth);
      setIsLoading(false);
    };
    
    checkScreenSize();
    
    const handleResize = () => {
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
      resizeTimeoutRef.current = setTimeout(checkScreenSize, 250);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
    };
  }, []);

  // Initialize background fade in
  useEffect(() => {
    const timer = setTimeout(() => {
      setBgOpacity(0.14);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  // Subtext rotation
  useEffect(() => {
    if (subtextIntervalRef.current) {
      clearInterval(subtextIntervalRef.current);
    }

    subtextIntervalRef.current = setInterval(() => {
      setCurrentSubtext(prev => (prev + 1) % subtextOptions.length);
    }, 3000);

    return () => {
      if (subtextIntervalRef.current) {
        clearInterval(subtextIntervalRef.current);
      }
    };
  }, [isMobile]);

  // Typewriter effect - FIXED with empty dependency array
  useEffect(() => {
    let currentVariation = 0;
    let isTyping = true;
    let isDeleting = false;
    let currentText = '';
    let lineIndex = 0;
    let charIndex = 0;
    let typingSpeed = 100;
    let lineDelay = 500;
    let variationDelay = 4000;
    let isInitialTypingComplete = false;

    const type = () => {
      if (!isInitialTypingComplete) {
        if (lineIndex < typewriterLines.length) {
          const currentLine = typewriterLines[lineIndex];
          if (charIndex <= currentLine.length) {
            currentText = currentLine.substring(0, charIndex);
            setTypedText(
              typewriterLines
                .slice(0, lineIndex)
                .join('\n') + 
              (lineIndex > 0 ? '\n' : '') + 
              currentText
            );
            charIndex++;
            typingSpeed = 100;
          } else {
            lineIndex++;
            charIndex = 0;
            typingSpeed = lineDelay;
          }
        } else {
          isInitialTypingComplete = true;
          typingSpeed = variationDelay;
        }
      } else {
        // Base text without the word "create" - just "What will\nyou "
        const baseText = typewriterLines[0] + '\n' + 'you ';
        
        if (isDeleting) {
          const currentVariationText = textVariations[currentVariation];
          if (charIndex > 0) {
            // Delete last character of the variation word
            setTypedText(baseText + currentVariationText.substring(0, charIndex - 1));
            charIndex--;
            typingSpeed = 50;
          } else {
            // Finished deleting, move to next variation
            isDeleting = false;
            currentVariation = (currentVariation + 1) % textVariations.length;
            charIndex = 0;
            typingSpeed = 500;
          }
        } else {
          const currentVariationText = textVariations[currentVariation];
          if (charIndex < currentVariationText.length) {
            // Type next character of the variation word
            setTypedText(baseText + currentVariationText.substring(0, charIndex + 1));
            charIndex++;
            typingSpeed = 100;
          } else {
            // Finished typing, wait then start deleting
            isDeleting = true;
            charIndex = currentVariationText.length;
            typingSpeed = variationDelay;
          }
        }
      }

      setShowCursor(true);
      if (cursorIntervalRef.current) {
        clearInterval(cursorIntervalRef.current);
        cursorIntervalRef.current = null;
      }

      if (typingSpeed > 300 && !cursorIntervalRef.current) {
        cursorIntervalRef.current = setInterval(() => {
          setShowCursor(prev => !prev);
        }, 500);
      }

      typewriterRef.current = setTimeout(type, typingSpeed);
    };

    type();

    return () => {
      if (typewriterRef.current) clearTimeout(typewriterRef.current);
      if (cursorIntervalRef.current) clearInterval(cursorIntervalRef.current);
      if (textRotationIntervalRef.current) clearTimeout(textRotationIntervalRef.current);
    };
  }, []); // EMPTY DEPENDENCY ARRAY - FIXED

  // Menu animation
  useEffect(() => {
    if (!isMobile && isMenuOpen && showBottomMenu) {
      let delay = 0;
      const newVisibility = [...menuItemsVisible];
      
      updatedMenuItems.forEach((_, index) => {
        setTimeout(() => {
          newVisibility[index] = true;
          setMenuItemsVisible([...newVisibility]);
        }, delay);
        delay += 100;
      });
    } else {
      setMenuItemsVisible([false, false, false, false]);
    }

    return () => {
      menuItemsVisible.forEach((_, index) => {
        clearTimeout(menuAnimationRef.current);
      });
    };
  }, [isMenuOpen, isMobile, showBottomMenu, updatedMenuItems]);

  // Background slideshow
  useEffect(() => {
    const preloadBackgrounds = () => {
      backgrounds.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    };
    
    preloadBackgrounds();

    const changeBackground = () => {
      setBgIndex(prev => (prev + 1) % backgrounds.length);
      
      const direction = Math.random() > 0.5 ? 1 : -1;
      const axis = Math.random() > 0.5 ? 'x' : 'y';
      
      setBgPosition({ x: 0, y: 0 });
      setBgScale(1.05);
      
      setTimeout(() => {
        setBgPosition({
          x: axis === 'x' ? direction * 5 : 0,
          y: axis === 'y' ? direction * 5 : 0
        });
      }, 10);
    };

    const direction = Math.random() > 0.5 ? 1 : -1;
    const axis = Math.random() > 0.5 ? 'x' : 'y';
    
    setBgPosition({ x: 0, y: 0 });
    setBgScale(1.05);
    
    setTimeout(() => {
      setBgPosition({
        x: axis === 'x' ? direction * 5 : 0,
        y: axis === 'y' ? direction * 5 : 0
      });
    }, 10);
    
    setBgOpacity(0.14);
    
    bgIntervalRef.current = setInterval(changeBackground, 8000);

    return () => {
      clearInterval(bgIntervalRef.current);
    };
  }, [backgrounds]);

    // Grid animation - OPTIMIZED: DOM updates for scroll, state for grid switching
  useEffect(() => {
    let lastTime = 0;
    const scrollSpeed = 15;
    const gridSize = 80;

    // Store base transforms for each grid style
    const baseTransforms = [
      '',                                                    // Grid 0
      'skewX(-15deg)',                                       // Grid 1
      'perspective(500px) rotateX(15deg)',                   // Grid 2
    ];

    const animateScroll = (time) => {
      if (!lastTime) lastTime = time;
      const delta = Math.min((time - lastTime) / 1000, 0.1); // Cap delta to avoid jumps
      lastTime = time;
      
      gridScrollRef.current = {
        x: (gridScrollRef.current.x + scrollSpeed * delta) % gridSize,
        y: (gridScrollRef.current.y + scrollSpeed * delta) % gridSize
      };
      
      // Update ALL grid elements directly in DOM
      const allGrids = document.querySelectorAll('.home-grid-layer');
      allGrids.forEach((grid, i) => {
        const styleIndex = i % 3;
        const tx = -gridScrollRef.current.x;
        const ty = -gridScrollRef.current.y;
        const base = baseTransforms[styleIndex];
        grid.style.transform = base 
          ? `${base} translate(${tx}px, ${ty}px)`
          : `translate(${tx}px, ${ty}px)`;
      });
      
      gridAnimationRef.current = requestAnimationFrame(animateScroll);
    };

    gridAnimationRef.current = requestAnimationFrame(animateScroll);

    // Grid style switching (keeps state for React-driven display toggling)
    const interval = setInterval(() => {
      lastGridChangeTime.current = performance.now();
      gridScrollRef.current = { x: 0, y: 0 };
      setActiveGrid((prev) => (prev + 1) % 3);
    }, 4000);

    return () => {
      if (gridAnimationRef.current) {
        cancelAnimationFrame(gridAnimationRef.current);
      }
      clearInterval(interval);
    };
  }, []);

  // Mobile touch handlers
  useEffect(() => {
    if (!isMobile) return;

    const handleTouchStart = (e) => {
      touchStartY.current = e.touches[0].clientY;
      touchStartX.current = e.touches[0].clientX;
      isDragging.current = true;
    };

    const handleTouchMove = (e) => {
      if (!isDragging.current) return;
      
      const currentY = e.touches[0].clientY;
      const currentX = e.touches[0].clientX;
      const deltaY = currentY - touchStartY.current;
      const deltaX = currentX - touchStartX.current;

      if (Math.abs(deltaY) > Math.abs(deltaX) && !isRightRevealed) {
        e.preventDefault();
        if (deltaY < 0) {
          const resistance = 0.7;
          const newOffset = Math.max(deltaY * resistance, -window.innerHeight * 0.8);
          setVerticalOffset(newOffset);
          
          if (newOffset < -window.innerHeight * 0.3 && !isBottomRevealed) {
            setIsBottomRevealed(true);
            setVerticalOffset(-window.innerHeight * 0.8);
          }
        } else {
          const resistance = 0.2;
          const newOffset = Math.min(deltaY * resistance, 0);
          setVerticalOffset(newOffset);
        }
      }
      else if (!isBottomRevealed) {
        e.preventDefault();
        if (deltaX < 0) {
          const resistance = 0.5;
          const newOffset = Math.max(deltaX * resistance, -window.innerWidth * 0.8);
          setHorizontalOffset(newOffset);
          
          if (newOffset < -window.innerWidth * 0.3 && !isRightRevealed) {
            setIsRightRevealed(true);
            setHorizontalOffset(-window.innerWidth * 0.8);
          }
        } else {
          const resistance = 0.2;
          const newOffset = Math.min(deltaX * resistance, 0);
          setHorizontalOffset(newOffset);
        }
      }
    };

    const handleTouchEnd = () => {
      if (!isBottomRevealed && !isRightRevealed) {
        setVerticalOffset(0);
        setHorizontalOffset(0);
      }
      isDragging.current = false;
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('touchstart', handleTouchStart, { passive: false });
      container.addEventListener('touchmove', handleTouchMove, { passive: false });
      container.addEventListener('touchend', handleTouchEnd);
    }

    return () => {
      if (container) {
        container.removeEventListener('touchstart', handleTouchStart);
        container.removeEventListener('touchmove', handleTouchMove);
        container.removeEventListener('touchend', handleTouchEnd);
      }
    };
  }, [isMobile, isBottomRevealed, isRightRevealed]);

  // Updated scroll handler for instant reopening
  useEffect(() => {
    if (isMobile) return;

    const handleScroll = (e) => {
      if (!isFunModeActive && (e.deltaX > 5 || e.deltaY > 5)) {
        setIsFunModeActive(true);
        setScrollTriggerActive(false);
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
        return;
      }

      if (isFunModeActive && (e.deltaX < -5 || e.deltaY < -5)) {
        exitFunMode();
      }
    };

    const handleMouseEnter = () => {
      if (!isFunModeActive) {
        setScrollTriggerActive(true);
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
      }
    };

    const handleMouseLeave = () => {
      if (!isFunModeActive) {
        setScrollTriggerActive(false);
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
      }
    };

    const triggerElement = scrollTriggerRef.current;
    if (triggerElement) {
      triggerElement.addEventListener('wheel', handleScroll, { passive: false });
      triggerElement.addEventListener('mouseenter', handleMouseEnter);
      triggerElement.addEventListener('mouseleave', handleMouseLeave);
    }

    return () => {
      if (triggerElement) {
        triggerElement.removeEventListener('wheel', handleScroll);
        triggerElement.removeEventListener('mouseenter', handleMouseEnter);
        triggerElement.removeEventListener('mouseleave', handleMouseLeave);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [isMobile, isFunModeActive]);

  const closeReveals = useCallback(() => {
    setIsBottomRevealed(false);
    setIsRightRevealed(false);
    setVerticalOffset(0);
    setHorizontalOffset(0);
  }, []);

    // Close bottom reveal when user first signs in
  useEffect(() => {
    if (authUser && !prevAuthUser.current && isBottomRevealed) {
      const timer = setTimeout(() => {
        closeReveals();
      }, 700);
      prevAuthUser.current = authUser;
      return () => clearTimeout(timer);
    }
    prevAuthUser.current = authUser;
  }, [authUser, isBottomRevealed, closeReveals]);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(!isMenuOpen);
  }, [isMenuOpen]);

  const exitFunMode = useCallback(() => {
    setIsFunModeActive(false);
    setScrollTriggerActive(false);
    setModelLoading(false);
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
  }, []);

  // Grid styles
    const gridStyles = useMemo(() => [
    {
      backgroundSize: '40px 40px',
      display: activeGrid === 0 ? 'block' : 'none',
      opacity: gridOpacity,
      transition: 'opacity 1s ease'
    },
    {
      backgroundSize: '50px 40px',
      backgroundPositionX: '20px',
      display: activeGrid === 1 ? 'block' : 'none',
      opacity: gridOpacity,
      transition: 'opacity 1s ease'
    },
    {
      backgroundSize: '40px 30px',
      backgroundPositionY: '10px',
      display: activeGrid === 2 ? 'block' : 'none',
      opacity: gridOpacity,
      transition: 'opacity 1s ease'
    }
  ], [activeGrid, gridOpacity]);

  // Don't render anything until we know if it's mobile or desktop
  if (isLoading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#1c1d1a',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{ color: 'white', fontFamily: 'avenir-lt-pro, sans-serif' }}>
          
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Fixed Background Layer */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#000000ff',
        zIndex: -3,
      }} />

      {/* Background Slideshow */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -2,
        overflow: 'hidden',
      }}>
        {backgrounds.map((bg, index) => (
          <div
            key={index}
            style={{
              position: 'absolute',
              top: '-10%',
              left: '-10%',
              right: '-10%',
              bottom: '-10%',
              backgroundImage: `url('${bg}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transform: index === bgIndex ? 
                `scale(${bgScale}) translate(${bgPosition.x}%, ${bgPosition.y}%)` : 'none',
              opacity: index === bgIndex ? bgOpacity : 0,
              mixBlendMode: 'soft-light',
              transition: 'transform 8s linear, opacity 2.3s ease',
              willChange: 'transform, opacity',
              backfaceVisibility: 'hidden',
            }}
          />
        ))}
      </div>

      {/* Grid Container */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: isFunModeActive ? '100vw' : '50vw',
        bottom: 0,
        zIndex: -1,
        overflow: 'hidden',
        transform: isMobile ? `translateX(${Math.min(horizontalOffset / 0, 0)}px)` : 'none',
        transition: isFunModeActive ? 'width 0.3s ease-out' : 'none',
        willChange: 'width'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '200vw',
          maskImage: isFunModeActive ? 'none' : 'linear-gradient(to right, transparent 0%, white 5%, white 95%, transparent 100%)',
          WebkitMaskImage: isFunModeActive ? 'none' : 'linear-gradient(to right, transparent 0%, white 5%, white 95%, transparent 100%)',
        }}>
          {gridStyles.map((style, index) => (
            <div key={index} className="home-grid-layer" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `
                linear-gradient(to right, white 1px, transparent 1px),
                linear-gradient(to bottom, white 1px, transparent 1px)
              `,
              ...style,
              willChange: 'transform'
            }} />
          ))}
        </div>
      </div>

      {/* 3D Model Container for Fun Mode */}
      {isFunModeActive && (
        <div ref={threeMountRef} style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 2,
          pointerEvents: 'auto'
        }} />
      )}

      {/* Loading Indicator for 3D Model */}
      {isFunModeActive && modelLoading && (
        <div style={{
          position: 'fixed',
          display: 'none',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 20,
          textAlign: 'center'
        }}>
          <div style={{
            width: '200px',
            height: '4px',
            backgroundColor: 'rgba(255,255,255,0.2)',
            margin: '15px 0',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${modelProgress}%`,
              height: '100%',
              backgroundColor: '#ffffffff',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <div style={{ color: 'white', fontFamily: 'avenir-lt-pro, sans-serif' }}>
            {Math.round(modelProgress)}% Loaded
          </div>
        </div>
      )}

      {/* Desktop Content - Only show when not on mobile */}
      {!isMobile && (
        <>
            {/* Hamburger Menu Button */}
          <div 
            style={{
              position: 'fixed',
              top: 'var(--safe-top)',
              left: '30px',
              zIndex: 20,
              cursor: 'pointer',
              transition: 'transform 0.3s ease, opacity 0.3s ease',
              opacity: isFunModeActive ? 0 : 1,
              pointerEvents: isFunModeActive ? 'none' : 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: '15px'
            }}
            onClick={toggleMenu} 
          >
            {/* Hamburger Icon */}
            <div>
              <div style={{
                width: '30px',
                height: '3px',
                backgroundColor: 'white',
                margin: '6px 0',
                borderRadius: '0px',
                transition: 'all 0.3s ease',
                transform: isMenuOpen ? 'translateY(9px) rotate(45deg)' : 'none'
              }} />
              
              <div style={{
                width: '30px',
                height: '3px',
                backgroundColor: 'white',
                margin: '6px 0',
                borderRadius: '0px',
                transition: 'all 0.3s ease',
                opacity: isMenuOpen ? 0 : 1
              }} />
              
              <div style={{
                width: '30px',
                height: '3px',
                backgroundColor: 'white',
                margin: '6px 0',
                borderRadius: '0px',
                transition: 'all 0.3s ease',
                transform: isMenuOpen ? 'translateY(-9px) rotate(-45deg)' : 'none'
              }} />
            </div>
            
            {/* Menu Text */}
            <span style={{
              color: 'white',
              fontFamily: 'avenir-lt-pro, sans-serif',
              fontSize: '1.2rem',
              fontWeight: 500
            }}>
              Menu
            </span>
          </div>

          {/* Main Desktop Navigation */}
          <div style={{
            position: 'fixed',
            bottom: '40px',
            left: '40px',
            zIndex: 10,
            display: 'flex',
            gap: '70px',
            opacity: isFunModeActive ? 0 : 1,
            pointerEvents: isFunModeActive ? 'none' : 'auto',
            transition: 'opacity 0.7s ease, margin-bottom 0.7s ease-out',
            marginBottom: isMenuOpen ? '0' : '120px',
          }}>
            {updatedMenuItems.map((item, index) => {
              const isDisabled = item.disabled;
              return (
                <div
                  key={index}
                  style={{
                    color: isDisabled ? '#777' : 'white',
                    fontFamily: 'avenir-lt-pro, sans-serif',
                    fontSize: '1.6rem',
                    marginTop: '-50px',
                    fontWeight: 500,
                    cursor: isDisabled ? 'default' : 'pointer',
                    opacity: menuItemsVisible[index] ? 1 : 0,
                    transform: menuItemsVisible[index] ? 'translateX(0)' : 'translateX(-20px)',
                    transition: 'opacity 0.3s ease, transform 0.3s ease, color 0.3s ease',
                    transitionDelay: `${index * 0.1}s`,
                  }}
                  onClick={() => handleMenuNavigation(item.path, isDisabled)}
                  onMouseEnter={(e) => {
                    if (!isDisabled) {
                      e.currentTarget.style.transform = 'scale(1.1)';
                      e.currentTarget.style.color = '#ccc';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isDisabled) {
                      e.currentTarget.style.transform = menuItemsVisible[index] ? 'translateX(0)' : 'translateX(-20px)';
                      e.currentTarget.style.color = 'white';
                    }
                  }}
                >
                  {item.name}
                </div>
              );
            })}
          </div>

          {/* Desktop Footer */}
          <div style={{
            position: 'fixed',
            bottom: '40px',
            left: '40px',
            zIndex: 9,
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            opacity: isMenuOpen || isFunModeActive ? 0 : 1,
            pointerEvents: isMenuOpen || isFunModeActive ? 'none' : 'auto',
            transform: isMenuOpen || isFunModeActive ? 'translateX(-20px)' : 'translateX(0)',
            transition: isMenuOpen ? 
              'opacity 0.1s ease, transform 0.1s ease' : 
              'opacity 0.3s ease 0.2s, transform 0.3s ease 0.2s',
          }}>
            {/* Social Icons */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '0px'
            }}>
              <div style={{
                color: '#ffffff',
                fontSize: '0.8rem',
                fontFamily: 'avenir-lt-pro, sans-serif',
                fontWeight: '400',
                marginRight: '-10px'
              }}>
                
              </div>
              {/* Instagram Icon */}
              <a href="https://instagram.com/tryoutlne" style={{ display: 'flex', alignItems: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.40-1.439-1.40z"/>
                </svg>
              </a>
              <a href="https://tiktok.com/@outlne" style={{ display: 'flex', alignItems: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                  <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 10.692 6.33 6.33 0 0 0 10.857-4.424V8.687a8.182 8.182 0 0 0 4.773 1.527V7.057a4.831 4.831 0 0 1-1.003-.371z"/>
                </svg>
              </a>
            </div>

            {/* Top separator for footer */}
            <div style={{
              width: '100%',
              height: '1px',
              backgroundColor: '#898989ff',
              margin: '5px 0 15px 0'
            }} />

            {/* Footer Links */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px'
            }}>
              {/* First stack: Blog, Careers, Press, Partnerships, Acknowledgements */}
              <div style={{
                display: 'flex',
                gap: '15px',
                alignItems: 'center',
                flexWrap: 'wrap'
              }}>
                {['Blog', 'Careers', 'Press', 'Partnerships', 'Acknowledgements'].map((item) => (
                  <a
                    key={item}
                    href={`/${item.toLowerCase().replace(' ', '-')}`}
                    className="footer-link"
                    style={{
                      color: 'white',
                      fontSize: '0.8rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease',
                      fontFamily: 'avenir-lt-pro, sans-serif',
                      fontWeight: '400'
                    }}
                    onMouseOver={(e) => e.target.style.color = '#40a3ff'}
                    onMouseOut={(e) => e.target.style.color = 'white'}
                  >
                    {item}
                  </a>
                ))}
              </div>

              {/* Second stack: Terms of Service, Privacy Policy */}
              <div style={{
                display: 'flex',
                gap: '30px',
                alignItems: 'center'
              }}>
                {[
                  { text: "Terms of Service", path: "/terms" },
                  { text: "Privacy Policy", path: "/privacy" }
                ].map((item) => (
                  <a
                    key={item.path}
                    href={item.path}
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.opener) {
                        window.opener.location.href = item.path;
                        window.close();
                      } else {
                        navigate(item.path);
                      }
                    }}
                    className="footer-link"
                    style={{
                      color: 'white',
                      fontSize: '0.8rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease',
                      fontFamily: 'avenir-lt-pro, sans-serif',
                      fontWeight: '400'
                    }}
                    onMouseOver={(e) => e.target.style.color = '#40a3ff'}
                    onMouseOut={(e) => e.target.style.color = 'white'}
                  >
                    {item.text}
                  </a>
                ))}
              </div>

              {/* Third stack: Copyright */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginTop: '2px'
              }}>
                {/* Copyright */}
                <div style={{
                  color: '#ffffff',
                  fontSize: '0.7rem',
                  fontFamily: 'avenir-lt-pro, sans-serif',
                  fontWeight: '400'
                }}>
                  © 2026 Outlne, All Rights Reserved
                </div>
              </div>
            </div>
          </div>

           <div style={{
            position: 'fixed',
            top: 'var(--safe-top)',
            right: '40px',
            zIndex: 10,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            textAlign: 'left',
            opacity: isFunModeActive ? 0 : 1,
            pointerEvents: isFunModeActive ? 'none' : 'auto',
            transition: 'opacity 0.3s ease'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img 
                src={LogoWhite} 
                alt="Outlne Logo"
                style={{
                  width: '40px',
                  height: 'auto',
                }}
              />
              <h1 style={{
                fontSize: '1.8rem',
                fontFamily: 'avenir-lt-pro, sans-serif',
                letterSpacing: '-1.2px',
                margin: 0,
                color: 'white',
                fontWeight: 500,
              }}>
                Outlne
              </h1>
            </div>
            <p style={{
              fontSize: '1rem',
              margin: '5px 0 0 0',
              color: 'white',
              fontFamily: 'avenir-lt-pro, sans-serif',
              fontWeight: '500'
            }}>
              Interior Design <span style={{
                backgroundColor: '#ffffff',
                color: '#2e2e2e',
                padding: '2px 8px',
                borderRadius: '4px',
                display: 'inline-block',
                minWidth: '60px',
                textAlign: 'center'
              }}>
                Editor
              </span>
            </p>
          </div>

          {/* Bottom Logo */}
          <div style={{
            position: 'fixed',
            bottom: '40px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10,
            display: showBottomMenu && window.innerWidth > 1250 ? 'block' : 'none',
            opacity: isMenuOpen || isFunModeActive ? 0 : 1,
            pointerEvents: isMenuOpen || isFunModeActive ? 'none' : 'auto',
            transition: 'opacity 0.3s ease'
          }}>
            <img 
              src={LogoWhite} 
              alt="Outlne Logo"
              style={{
                width: '40px',
                height: 'auto',
                opacity: 1
              }}
            />
          </div>

          {/* Desktop Video Container */}
          <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '300px',
            aspectRatio: '9/16',
            minWidth: '300px',
            border: '2px solid white',
            borderRadius: '40px',
            overflow: 'visible',
            padding: '10px',
            boxSizing: 'border-box',
            zIndex: 5,
            opacity: isFunModeActive ? 0 : 1,
            pointerEvents: isFunModeActive ? 'none' : 'auto',
            transition: 'opacity 0.3s ease'
          }}>
            <div style={{
              width: '100%',
              height: '100%',
              borderRadius: '30px',
              overflow: 'hidden',
              position: 'relative'
            }}>
              {/* Skeleton Shimmer Overlay - Always visible */}
              <div style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                borderRadius: '30px',
                backgroundColor: '#2e2e2e',
                overflow: 'hidden',
                zIndex: 1,
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '50%',
                  height: '100%',
                  background: `linear-gradient(
                    90deg,
                    transparent 0%,
                    rgba(255, 255, 255, 0.6) 50%,
                    transparent 100%
                  )`,
                  animation: 'shimmer 1.5s infinite',
                  filter: 'blur(8px)',
                }}></div>
              </div>
              
              <iframe
                src="https://player.vimeo.com/video/1111794326?autoplay=1&loop=1&autopause=0&muted=1&background=1&title=0&byline=0&portrait=0"
                style={{
                  marginLeft: '-3%',
                  width: '105%',
                  height: '105%',
                  objectFit: 'cover',
                  opacity: isVideoLoaded ? 1 : 0,
                  transition: 'opacity 0.3s ease-in-out',
                  transform: 'scale(1.1)',
                  zIndex: 2,
                  position: 'relative'
                }}
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
                onLoad={() => {
                  setIsVideoLoaded(true);
                }}
              ></iframe>
              
              {/* Desktop Profile Avatar Button - Only show on desktop */}
              <button 
                onClick={() => setShowProfileCard(true)} 
                style={{
                  position: 'absolute', 
                  top: '15px', 
                  right: '15px', 
                  zIndex: 10,
                  width: '35px', 
                  height: '35px', 
                  borderRadius: '50%', 
                  border: '2px solid #88b7ff',
                  backgroundColor: '#88b7ff', 
                  cursor: 'pointer', 
                  padding: 0, 
                  overflow: 'hidden',
                  transition: 'transform 0.2s ease, border-color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.15)';
                  e.currentTarget.style.borderColor = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.borderColor = '#88b7ff';
                }}
              >
                <img 
                  src={getAvatarUrl()} 
                  alt="Profile" 
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover' 
                  }} 
                />
              </button>

              {/* Profile Card Layer */}
              {showProfileCard && (
                <div style={{
                  position: 'absolute',
                  top: '-2px', 
                  left: '-2px', 
                  right: '-2px', 
                  bottom: '-2px',
                  zIndex: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(46, 46, 46, 0.85)',
                  backdropFilter: 'blur(14px)',
                  WebkitBackdropFilter: 'blur(14px)',
                  borderRadius: '32px',
                  padding: '20px',
                  boxSizing: 'border-box',
                  overflowY: 'auto'
                }}>
                  {/* Back Button */}
                  <button 
                    onClick={handleCloseProfileCard}
                    style={{
                      position: 'absolute',
                      top: '15px',
                      left: '15px',
                      background: 'none',
                      border: 'none',
                      color: '#aaa',
                      fontSize: '1rem',
                      fontFamily: 'avenir-lt-pro, sans-serif',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      padding: '5px 10px',
                      transition: 'color 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#fff'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#aaa'}
                  >
                    ← Back
                  </button>

                  {/* Profile Content - Centered vertically */}
                  <div style={{
                    width: '100%',
                    maxWidth: '260px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: 'auto 0'
                  }}>
                    {!authUser ? (
                      // Logged Out View
                      <>
                        <div style={{
                          width: '80px',
                          height: '80px',
                          borderRadius: '50%',
                          border: '3px solid #88b7ff',
                          overflow: 'hidden',
                          marginBottom: '20px'
                        }}>
                          <img 
                            src={DefaultAvatarIcon} 
                            alt="Default Avatar" 
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        </div>
                        <p style={{
                          color: '#aaa',
                          fontFamily: 'avenir-lt-pro, sans-serif',
                          fontSize: '0.9rem',
                          textAlign: 'center',
                          margin: '0 0 25px 0'
                        }}>
                          You are not logged in
                        </p>
                      </>
                    ) : (
                      // Logged In View
                      <>
                        {/* Hidden file input for avatar upload */}
                        <input 
                          id="avatar-upload-desktop"
                          type="file" 
                          accept="image/*" 
                          style={{ display: 'none' }} 
                          onChange={handleAvatarChange} 
                        />
                        
                        {/* Clickable Avatar */}
                        <label 
                          htmlFor="avatar-upload-desktop"
                          style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            border: '2px solid #88b7ff',
                            overflow: 'hidden',
                            marginBottom: avatarPreview ? '10px' : '20px',
                            cursor: 'pointer',
                            display: 'block'
                          }}
                        >
                          <img 
                            src={getAvatarUrl()} 
                            alt="Profile" 
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        </label>

                        {/* Save/Cancel buttons for avatar */}
                        {avatarPreview && (
                          <div style={{
                            display: 'flex',
                            gap: '10px',
                            marginBottom: '15px'
                          }}>
                            <button 
                              onClick={handleSaveAvatar}
                              disabled={isSavingAvatar}
                              style={{
                                padding: '6px 16px',
                                backgroundColor: '#88B7FF',
                                color: 'white',
                                border: 'none',
                                borderRadius: '20px',
                                fontFamily: 'avenir-lt-pro, sans-serif',
                                fontSize: '0.8rem',
                                cursor: 'pointer',
                                opacity: isSavingAvatar ? 0.6 : 1
                              }}
                            >
                              {isSavingAvatar ? 'Saving...' : 'Save'}
                            </button>
                            <button 
                              onClick={handleCancelAvatar}
                              style={{
                                padding: '6px 16px',
                                backgroundColor: 'transparent',
                                color: '#aaa',
                                border: '1px solid #aaa',
                                borderRadius: '20px',
                                fontFamily: 'avenir-lt-pro, sans-serif',
                                fontSize: '0.8rem',
                                cursor: 'pointer'
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        )}

                                                {/* Display Name with Edit */}
                        <div style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px',
                          marginBottom: '10px'
                        }}>
                          {isEditingName ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', alignItems: 'center' }}>
                              <input
                                type="text"
                                value={tempUserName}
                                onChange={(e) => setTempUserName(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '6px 10px',
                                  backgroundColor: '#444',
                                  color: 'white',
                                  border: '1px solid #88b7ff',
                                  borderRadius: '6px',
                                  fontFamily: 'avenir-lt-pro, sans-serif',
                                  fontSize: '0.85rem',
                                  outline: 'none',
                                  boxSizing: 'border-box'
                                }}
                              />
                              <div style={{ display: 'flex', gap: '8px' }}>
                                <button
                                  onClick={handleSaveProfileToFirebase}
                                  style={{
                                    padding: '6px 16px',
                                    backgroundColor: '#88B7FF',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontFamily: 'avenir-lt-pro, sans-serif',
                                    fontSize: '0.8rem',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Save
                                </button>
                                <button
                                  onClick={() => {
                                    setIsEditingName(false);
                                    setTempUserName(userName);
                                  }}
                                  style={{
                                    padding: '6px 16px',
                                    backgroundColor: 'transparent',
                                    color: '#aaa',
                                    border: '1px solid #aaa',
                                    borderRadius: '6px',
                                    fontFamily: 'avenir-lt-pro, sans-serif',
                                    fontSize: '0.8rem',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <p style={{
                                color: '#fff',
                                fontFamily: 'avenir-lt-pro, sans-serif',
                                fontSize: '1rem',
                                margin: 0,
                                fontWeight: 500
                              }}>
                                {getDisplayName()}
                              </p>
                              <button
                                onClick={() => {
                                  setIsEditingName(true);
                                  setTempUserName(userName);
                                }}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  color: 'white',
                                  cursor: 'pointer',
                                  padding: '2px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  transition: 'color 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#88b7ff'}
                                onMouseLeave={(e) => e.currentTarget.style.color = 'white'}
                              >
                                <LuPencilLine size={16} />
                              </button>
                            </>
                          )}
                        </div>

                          <p style={{
                            color: '#aaa',
                            fontFamily: 'avenir-lt-pro, sans-serif',
                            fontSize: '0.75rem',
                            margin: '0 0 12px 0'
                          }}>
                            {authUser?.email}
                          </p>

                                                  {/* ========== CURRENT PLAN (signed in only) ========== */}
              {authUser && (
                <div style={{
                  width: '70%',
                  maxWidth: '260px',
                  background: 'none',
                  padding: '10px 14px',
                  borderRadius: '12px',
                  color: 'white',
                  fontFamily: 'avenir-lt-pro, sans-serif',
                  fontSize: '0.8rem',
                  textAlign: 'center',
                  
                  marginTop: '-20px',
                  marginBottom: '10px',
                  flexShrink: 0
                }}>
                  <span style={{ color: '#aaa', marginRight: '6px' }}>Current Plan:</span>
                  <span style={{ color: '#ffffffff', fontWeight: '600' }}>
                    {userData?.subscription?.planName || userData?.pendingPlan?.name || 'Starter'}
                  </span>
                  {(userData?.subscription?.billingCycle || userData?.pendingPlan?.billingCycle) && (
  <span style={{ color: '#aaa', fontSize: '0.7rem', marginLeft: '6px' }}>
    ({userData?.subscription?.billingCycle || userData?.pendingPlan?.billingCycle})
  </span>
)}
                </div>
              )}
            

                          <button 
                            onClick={() => setShowEmailChangePopup(true)}
                            style={{
                              width: '100%',
                              padding: '8px',
                              backgroundColor: '#444',
                              color: 'white',
                              border: 'none',
                              borderRadius: '8px',
                              fontFamily: 'avenir-lt-pro, sans-serif',
                              fontSize: '0.85rem',
                              cursor: 'pointer',
                              marginBottom: '8px'
                            }}
                          >
                            Change Email
                          </button>
                          <button 
                            onClick={() => setShowPasswordChangePopup(true)}
                            style={{
                              width: '100%',
                              padding: '8px',
                              backgroundColor: '#444',
                              color: 'white',
                              border: 'none',
                              borderRadius: '8px',
                              fontFamily: 'avenir-lt-pro, sans-serif',
                              fontSize: '0.85rem',
                              cursor: 'pointer',
                              marginBottom: '8px'
                            }}
                          >
                            Change Password
                          </button>
                          <button 
                            onClick={() => setShowDeleteDisclaimer(true)}
                            style={{
                              width: '100%',
                              padding: '8px',
                              backgroundColor: '#444',
                              color: '#ffffffff',
                              
                              borderRadius: '8px',
                              fontFamily: 'avenir-lt-pro, sans-serif',
                              fontSize: '0.85rem',
                              cursor: 'pointer',
                              marginBottom: '12px'
                            }}
                          >
                            Delete Account
                          </button>
                        
                      </>
                    )}
                  </div>
                </div>
              )}
              
              {/* Desktop Dashboard Quick Access Button - Bottom Left of Video */}
              {authUser && (
                <div style={{
                  position: 'absolute',
                  bottom: '15px',
                  left: '10px',
                  zIndex: 25,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '5px'
                }}>
                  <div style={{
                    color: 'white',
                    fontFamily: 'avenir-lt-pro, sans-serif',
                    fontSize: '0.70rem',
                    textAlign: 'left',
                    padding: '2px 6px',
                    borderRadius: '20px',
                    backdropFilter: 'blur(5px)',
                    WebkitBackdropFilter: 'blur(5px)',
                    whiteSpace: 'nowrap'
                  }}>
                    Open Dashboard
                  </div>
                  <button 
                                        onClick={(e) => {
    e.stopPropagation();
    e.preventDefault();
    handleDashboardClick(e);
}}
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      border: '1px solid white',
                      backgroundColor: 'transparent',
                      color: 'white',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      
                      outline: 'none',
                      overflow: 'hidden',
                      position: 'relative'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.0.4)';
                      e.currentTarget.style.borderColor = '#ffffffff';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.borderColor = 'white';
                    }}
                  >
                    {/* Moving grid background */}
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      borderRadius: '50%',
                      backgroundImage: `
                        linear-gradient(to right, rgba(239, 239, 239, 0.25) 1px, transparent 1px),
                        linear-gradient(to bottom, rgba(239, 239, 239, 0.25) 1px, transparent 1px)
                      `,
                      backgroundSize: '12px 12px',
                      animation: 'gridScroll 2s linear infinite',
                      zIndex: 0,
                      mixBlendMode: 'hard-light',
                      backdropFilter: 'blur(4px)',
                      WebkitBackdropFilter: 'blur(4px)'
                    }} />
                    <MdOutlineSpaceDashboard 
                      size={20} 
                      style={{ 
                        position: 'relative', 
                        zIndex: 1,
                        animation: 'iconPulse 2.0s ease-in-out infinite'
                      }} 
                    />
                  </button>
                </div>
              )}
              {/* CSS to hide Vimeo logo */}
              <style>
                {`
                  .PersistentLogo_module_persistentLogo__e4ddb428 {
                    display: none !important;
                  }
                  [data-persistent-logo="true"] {
                    display: none !important;
                  }
                  [data-vimeo-small-icon="true"] {
                    display: none !important;
                  }
                `}
              </style>

              {/* Desktop Typewriter Text */}
<div style={{
  position: 'fixed',
  left: 'calc(50% + 200px)',
  top: '2%',
  zIndex: 6,
  color: 'white',
  fontFamily: 'avenir-lt-pro, sans-serif',
  fontSize: '1.6rem',
  fontWeight: 500,
  letterSpacing: '-0.5px',
  textAlign: 'left',
  whiteSpace: 'nowrap',
  opacity: isFunModeActive ? 0 : 1,
  pointerEvents: isFunModeActive ? 'none' : 'auto',
  transition: 'opacity 0.3s ease'
}}>
                 <span style={{
                  whiteSpace: 'pre',
                  lineHeight: '1.2'
                }}>
                  {typedText}
                  <span style={{ 
                    opacity: showCursor ? 1 : 0,
                    animation: 'blink 1s infinite',
                    display: 'inline',
                    marginLeft: '2px'
                  }}>█</span>
                </span>
              </div>

               

              <div 
  className="subtext"
  style={{
    position: 'fixed',
    left: 'calc(50% + 200px)',
    top: authUser ? 'calc(15% + 45px)' : 'calc(15% + 45px)',
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingTop: '5px',
    paddingBottom: '5px',
    borderRadius: '5px',
    zIndex: 6,
    color: 'black',
    fontFamily: 'monospace',
    fontSize: '0.7rem',
    fontWeight: 500,
    textAlign: 'left',
    backgroundColor: 'white',
    fontStyle: 'italic',
    whiteSpace: 'nowrap',
    opacity: isFunModeActive ? 0 : 1,
    pointerEvents: isFunModeActive ? 'none' : 'auto',
    transition: 'opacity 0.3s ease, color 0.3s ease'
  }}
>
                {subtextOptions[currentSubtext]}
              </div>

              {/* Desktop Buttons - Sign Up/Login (signed out) or Sign Out (signed in) */}
<div style={{
  position: 'fixed',
  left: 'calc(50% + 200px)',
  top: authUser ? 'calc(15% + 105px)' : 'calc(15% + 290px)',
  zIndex: 6,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '15px',
  opacity: isFunModeActive ? 0 : 1,
  pointerEvents: isFunModeActive ? 'none' : 'auto',
  transition: 'opacity 0.3s ease'
}}>
                {!authUser ? (
                  <>
                    <button 
                      className="signup-btn"
                     onClick={() => handleAuthClick('signup')}
                      style={{
                        backgroundColor: 'white',
                        color: '#2e2e2e',
                        border: 'none',
                        padding: '10px 30px',
                        fontSize: '1.2rem',
                        fontFamily: 'avenir-lt-pro, sans-serif',
                        fontWeight: 500,
                        borderRadius: '30px',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s ease',
                        width: '150px'
                      }}
                    >
                      Sign Up
                    </button>
                    <button 
                      className="login-btn"
                     onClick={() => handleAuthClick('login')}
                      style={{
                        backgroundColor: '#ffffffff',
                        color: 'black',
                        padding: '10px 30px',
                        fontSize: '1.2rem',
                        fontFamily: 'avenir-lt-pro, sans-serif',
                        fontWeight: 500,
                        borderRadius: '30px',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s ease',
                        width: '150px'
                      }}
                    >
                      Log In
                    </button>
                  </>
                ) : (
                  <button 
                    className="signup-btn"
                    onClick={handleSignOut}
                    style={{
                      backgroundColor: 'white',
                      color: '#2e2e2e',
                      border: 'none',
                      padding: '10px 30px',
                      fontSize: '1.2rem',
                      fontFamily: 'avenir-lt-pro, sans-serif',
                      fontWeight: 500,
                      borderRadius: '30px',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s ease',
                      width: '150px'
                    }}
                  >
                    Sign Out
                  </button>
                )}
              </div>
            </div>
            
            {/* User greeting text moved outside video container */}
            <div style={{
              position: 'absolute',
              bottom: '-35px',
              left: '0',
              right: '0',
              textAlign: 'center',
              color: 'white',
              fontFamily: 'avenir-lt-pro, sans-serif',
              fontSize: '0.9rem',
              fontWeight: 400,
              paddingBottom: '5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}>
              <span style={{
                width: '5px',
                height: '5px',
                borderRadius: '50%',
                backgroundColor: authUser ? '#6bf41cff' : '#ff6b6b',
                display: 'inline-block',
                flexShrink: 0
              }}></span>
              {authUser ? `Hi ${getDisplayName()}, Welcome` : 'You are not logged in'}
            </div>
          </div>

          {/* Desktop Scroll Trigger Area */}
          <div 
            ref={scrollTriggerRef}
            style={{
              position: 'fixed',
              bottom: '20px',
              right: '20px',
              width: '150px',
              height: '100px',
              zIndex: 20,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              cursor: 'pointer',
            }}
          >
            <div style={{
              color: 'white',
              fontSize: '0.8rem',
              fontStyle: 'italic',
              marginBottom: '10px',
              textAlign: 'right',
              animation: isFunModeActive ? 'none' : 'blink 2s ease-in-out infinite'
            }}>
              {isFunModeActive ? 'Scroll right to exit' : 'Scroll left here for something fun'}
            </div>
            <img 
              src={LeftSwipe} 
              alt="Swipe left"
              style={{
                paddingTop:'10px',
                width: '10px',
                height: 'auto',
                animation: isFunModeActive ? 'none' : 'floatHorizontal 3s ease-in-out infinite',
                transform: isFunModeActive ? 'scaleX(-1)' : 'none'
              }}
            />
          </div>

           {/* Fun Mode Close Button */}
          {isFunModeActive && (
            <div 
              style={{
                position: 'fixed',
                top: 'var(--safe-top)',
                right: '30px',
                zIndex: 30,
                fontSize: '2rem',
                color: 'white',
                cursor: 'pointer',
                opacity: isFunModeActive ? 1 : 0,
                pointerEvents: isFunModeActive ? 'auto' : 'none',
                transition: 'opacity 0.3s ease'
              }}
              onClick={exitFunMode}
            >
              ×
            </div>
          )}
        </>
      )}

      {/* Mobile Content */}
      {isMobile && (
        <>

          {/* Add to Home Screen Button - Floating - Only show when NOT in standalone mode */}
          {!isStandalone && (
            <div style={{
              position: 'fixed',
              bottom: '20px',
              left: '20px',
              zIndex: 15,
              opacity: isBottomRevealed || isRightRevealed ? 0 : 1,
              pointerEvents: isBottomRevealed || isRightRevealed ? 'none' : 'auto',
              transform: `translateY(${verticalOffset}px) translateX(${horizontalOffset}px) scale(${mobileScale})`,
              transition: 'opacity 0.3s ease-out, transform 0.3s ease-out',
              transformOrigin: 'left bottom'
            }}>
              <p 
                style={{
                  width: '70px',
                  color: 'white',
                  fontSize: '8px',
                  textAlign: 'left',
                  marginLeft: '3px'
                }}> 
                Add to <br />Homescreen
              </p>

              <div 
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  border: 'solid 2px white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onClick={() => setShowA2HSOverlay(true)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <MdOutlineAddToHomeScreen 
                    size={18} 
                    color="#ffffffff" 
                  />
                </div>
              </div>
            </div>
          )}

          {/* Add to Home Screen Overlay - Carousel */}
          {showA2HSOverlay && (
            <div 
              className="a2hs-background"
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                zIndex: 100,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                opacity: showA2HSOverlay ? 1 : 0,
                transition: 'opacity 0.3s ease'
              }} 
              onClick={handleCloseA2HS}
            >
              {/* Left Arrow - Outside container */}
              <div 
                className="a2hs-arrow"
                style={{
                  position: 'absolute',
                  left: '30px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: currentStep > 0 ? 'pointer' : 'default',
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  backgroundColor: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease',
                  zIndex: 101,
                  opacity: currentStep > 0 ? 1 : 0.3
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  currentStep > 0 && setCurrentStep(prev => prev - 1);
                }}
                onMouseEnter={(e) => {
                  if (currentStep > 0) {
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentStep > 0) {
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                  }
                }}
              >
                <img 
                  src={LeftSwipe} 
                  alt="Previous"
                  style={{
                    width: '20px',
                    height: 'auto',
                    filter: currentStep > 0 ? 'brightness(1)' : 'brightness(0.5)'
                  }}
                />
              </div>

              {/* Right Arrow - Outside container */}
              <div 
                className="a2hs-arrow"
                style={{
                  position: 'absolute',
                  right: '30px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: currentStep < 3 ? 'pointer' : 'default',
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  backgroundColor: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease',
                  zIndex: 101,
                  opacity: currentStep < 3 ? 1 : 0.3
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  currentStep < 3 && setCurrentStep(prev => prev + 1);
                }}
                onMouseEnter={(e) => {
                  if (currentStep < 3) {
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentStep < 3) {
                    e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                  }
                }}
              >
                <img 
                  src={LeftSwipe} 
                  alt="Next"
                  style={{
                    width: '20px',
                    height: 'auto',
                    transform: 'rotate(180deg)',
                    filter: currentStep < 3 ? 'brightness(1)' : 'brightness(0.5)'
                  }}
                />
              </div>

              {/* Main Overlay Container */}
              <div 
                className={`a2hs-overlay ${showA2HSOverlay ? '' : 'a2hs-overlay-closing'}`}
                style={{
                  backgroundColor: '#2e2e2e',
                  borderRadius: '20px',
                  padding: '20px',
                  maxWidth: '240px',
                  width: '100%',
                  border: '2px solid white',
                  position: 'relative',
                  overflow: 'hidden',
                  opacity: showA2HSOverlay ? 1 : 0,
                  animation: showA2HSOverlay ? 'fadeInOverlay 0.6s ease-out forwards' : 'none',
                  transformOrigin: 'center',
                  boxSizing: 'border-box'
                }} 
                onClick={(e) => e.stopPropagation()}
              >
                {/* Close Button */}
                <div 
                  style={{
                    position: 'absolute',
                    top: '15px',
                    right: '20px',
                    fontSize: '2rem',
                    color: 'white',
                    cursor: 'pointer',
                    lineHeight: 1,
                    width: '30px',
                    height: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10
                  }}
                  onClick={handleCloseA2HS}
                >
                  ×
                </div>

                {/* Title */}
                <h3 style={{
                  color: 'white',
                  fontFamily: 'avenir-lt-pro, sans-serif',
                  fontSize: '1rem',
                  fontWeight: 500,
                  margin: '0 0 20px 0',
                  textAlign: 'center',
                  paddingRight: '0px'
                }}>
                  Setup Guide
                </h3>

                {/* Carousel Container */}
                <div style={{
                  position: 'relative',
                  marginBottom: '25px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {/* Content Area */}
                  <div 
                    style={{
                      width: '100%',
                      minHeight: '200px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      touchAction: 'pan-y'
                    }}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                  >
                    {/* Step Content */}
                    <div style={{
                      textAlign: 'center',
                      width: '100%'
                    }}>
                      {currentStep === 0 && (
                        <>
                          <div style={{
                            width: '100%',
                            height: '222px',
                            borderRadius: '10px',
                            marginBottom: '15px',
                            backgroundColor: '#3f3f3f',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden'
                          }}>
                            <img 
                              src="https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/addtohomescreen_assets%2Fstep1.jpg?alt=media&token=fd5af681-395e-462a-b736-7e3bd4fad9af" 
                              alt=""
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'bottom'
                              }}
                            />
                          </div>
                          <p style={{
                            color: 'white',
                            fontFamily: 'avenir-lt-pro, sans-serif',
                            fontSize: '1rem',
                            margin: '0',
                            fontWeight: 500
                          }}>
                            Tap the Share button in your browser
                          </p>
                        </>
                      )}

                      {currentStep === 1 && (
                        <>
                          <div style={{
                            width: '100%',
                            height: '222px',
                            borderRadius: '10px',
                            marginBottom: '15px',
                            backgroundColor: '#3f3f3f',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden'
                          }}>
                            <img 
                              src="https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/addtohomescreen_assets%2Fstep2.jpg?alt=media&token=2cf2ff17-4de3-478c-ad80-0ff119e7f949" 
                              alt=""
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'bottom'
                              }}
                            />
                          </div>
                          <p style={{
                            color: 'white',
                            fontFamily: 'avenir-lt-pro, sans-serif',
                            fontSize: '1rem',
                            margin: '0',
                            fontWeight: 500
                          }}>
                            Then tap the<br></br> (More) "..." Button
                          </p>
                        </>
                      )}

                      {currentStep === 2 && (
                        <>
                          <div style={{
                            width: '100%',
                            height: '222px',
                            borderRadius: '10px',
                            marginBottom: '15px',
                            backgroundColor: '#3f3f3f',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden'
                          }}>
                            <img 
                              src="https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/addtohomescreen_assets%2Fstep3.jpg?alt=media&token=a6011f82-7def-4006-95ab-ff44dd58e20b" 
                              alt=""
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'bottom'
                              }}
                            />
                          </div>
                          <p style={{
                            color: 'white',
                            fontFamily: 'avenir-lt-pro, sans-serif',
                            fontSize: '1rem',
                            margin: '0',
                            fontWeight: 500
                          }}>
                            Tap "Add to Home Screen" 
                          </p>
                        </>
                      )}

                      {currentStep === 3 && (
                        <>
                          <div style={{
                            width: '100%',
                            height: '222px',
                            borderRadius: '10px',
                            marginBottom: '15px',
                            backgroundColor: '#3f3f3f',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden'
                          }}>
                            <img 
                              src="https://firebasestorage.googleapis.com/v0/b/outlne-6a95c.firebasestorage.app/o/addtohomescreen_assets%2Fstep4.jpg?alt=media&token=ae5d10a7-cb38-4b98-a735-3ccc34d6c190" 
                              alt=""
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                            />
                          </div>
                          <p style={{
                            color: 'white',
                            fontFamily: 'avenir-lt-pro, sans-serif',
                            fontSize: '1rem',
                            margin: '0',
                            fontWeight: 500
                          }}>
                            Lastly, Tap "Add"<br></br><i>Done.</i>
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Note with Blinking Animation */}
                <p style={{
                  color: '#ccc',
                  fontFamily: 'avenir-lt-pro, sans-serif',
                  fontSize: '0.8rem',
                  textAlign: 'center',
                  margin: '0',
                  fontStyle: 'italic',
                  animation: currentStep < 3 ? 'blink 2s ease-in-out infinite' : 'none'
                }}>
                  {currentStep === 3 ? 'You can now close this tutorial.' : 'Swipe or use arrows to continue'}
                </p>
              </div>
            </div>
          )}

           {/* Mobile Header - Left Side */}
          <div style={{
            position: 'fixed',
            top: 'var(--safe-top)',
            left: '20px',
            zIndex: 15,
            textAlign: 'left',
            transform: isRightRevealed ? `translateX(${-window.innerWidth * 0.8}px)` : 'none',
            transition: 'transform 0.3s ease-out'
          }}>
            <h1 style={{
              fontSize: '1.5rem',
              fontFamily: 'avenir-lt-pro, sans-serif',
              letterSpacing: '-1.2px',
              margin: 0,
              color: 'white',
              fontWeight: 500,
            }}>
              Outlne
            </h1>
            <p style={{
              fontSize: '0.9rem',
              margin: '5px 0 0 0',
              color: 'white',
              fontFamily: 'avenir-lt-pro, sans-serif',
              fontWeight: '500'
            }}>
              Interior Design <span style={{
                backgroundColor: '#ffffff',
                color: '#2e2e2e',
                padding: '2px 6px',
                borderRadius: '4px',
                display: 'inline-block',
                minWidth: '50px',
                textAlign: 'center'
              }}>
                Editor
              </span>
            </p>
          </div>

           {/* Mobile Logo */}
          <div style={{
            position: 'fixed',
            top: 'var(--safe-top)',
            right: '20px',
            zIndex: 25,
            transform: isRightRevealed ? `translateX(-${window.innerWidth * 0.8 - 80}px)` : 'translateX(0)',
            transition: 'transform 0.3s ease-out',
            willChange: 'transform'
          }}>
            <img 
              src={LogoWhite} 
              alt="Outlne Logo"
              style={{
                width: '40px',
                height: '40px',
                objectFit: 'contain'
              }}
            />
          </div>
          
          {/* Mobile Content Container */}
          <div ref={containerRef} style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            height: isMobile ? 'calc(var(--vh, 1vh) * 100)' : '100%',
            overflow: 'hidden',
            zIndex: 5,
            transform: `translateY(${isBottomRevealed ? -window.innerHeight * 0.8 : verticalOffset}px) translateX(${isRightRevealed ? -window.innerWidth * 0.8 : horizontalOffset / 2}px)`,
            transition: 'transform 0.3s ease-out',
            opacity: showMobileMainContent ? 1 : 0,
            pointerEvents: showMobileMainContent ? 'auto' : 'none',
          }}>
         
              {/* Mobile Video Container - Updated with opacity control */}
            <div style={{
              position: 'absolute',
              top: 'calc(50% + 10px)',
              left: '50%',
              transform: `translate(-50%, -50%) scale(${mobileScale})`,
              width: 'min(72vw, 300px)',
              aspectRatio: '9/16',
              border: '2px solid white',
              borderRadius: '30px',
              overflow: 'visible',
              padding: '8px',
              boxSizing: 'border-box',
              zIndex: 10,
              transformOrigin: 'center center',
              transition: 'transform 0.3s ease-out, opacity 0.3s ease',
              opacity: (showMobileMainContent && !showA2HSOverlay) ? 1 : 0,
              pointerEvents: (showMobileMainContent && !showA2HSOverlay) ? 'auto' : 'none',
            }}>
              <div style={{
                width: '100%',
                height: '100%',
                borderRadius: '22px',
                overflow: 'hidden',
                position: 'relative'
              }}>
                {/* Skeleton Shimmer Overlay - Always visible */}
                <div style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '100%',
                  height: '100%',
                  borderRadius: '22px',
                  backgroundColor: '#2e2e2e',
                  overflow: 'hidden',
                  zIndex: 1,
                }}>
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '50%',
                    height: '100%',
                    background: `linear-gradient(
                      90deg,
                      transparent 0%,
                      rgba(255, 255, 255, 0.6) 50%,
                      transparent 100%
                    )`,
                    animation: 'shimmer 1.5s infinite',
                    filter: 'blur(8px)',
                  }}></div>
                </div>

                <iframe
                  src="https://player.vimeo.com/video/1111794326?autoplay=1&loop=1&autopause=0&muted=1&background=1&title=0&byline=0&portrait=0&badge=0"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    marginLeft: '-3%',
                    width: '105%',
                    height: '105%',
                    opacity: isVideoLoaded ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out',
                    transform: 'scale(1.1)',
                    zIndex: 2
                  }}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  onLoad={() => {
                    setIsVideoLoaded(true);
                  }}
                  title="Outlne Preview"
                ></iframe>

                                                {/* Mobile Dashboard Quick Access Button - Bottom Left */}
                {authUser && (
                  <div style={{
                    position: 'absolute',
                    bottom: '15px',
                    left: '10px',
                    zIndex: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: '5px'
                  }}>
                    <div style={{
                      color: 'white',
                      fontFamily: 'avenir-lt-pro, sans-serif',
                      fontSize: '0.70rem',
                      textAlign: 'left',
                      padding: '2px 6px',
                      borderRadius: '20px',
                      backdropFilter: 'blur(5px)',
                      WebkitBackdropFilter: 'blur(5px)',
                      whiteSpace: 'nowrap'
                    }}>
                      
                    </div>
                    <button 
                      onClick={handleDashboardClick}
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        border: '1px solid white',
                        backgroundColor: 'transparent',
                        color: 'white',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 0,
                        animation: 'pulseBorder 2.0s ease-in-out infinite',
                        outline: 'none',
                        overflow: 'hidden',
                        position: 'relative'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.1)';
                        e.currentTarget.style.borderColor = '#88b7ff';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.borderColor = 'white';
                      }}
                    >
                                            {/* Moving grid background */}
                                            <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        borderRadius: '50%',
                        backgroundImage: `
                          linear-gradient(to right, rgba(239, 239, 239, 0.25) 1px, transparent 1px),
                          linear-gradient(to bottom, rgba(239, 239, 239, 0.25) 1px, transparent 1px)
                        `,
                        
                        backgroundSize: '12px 12px',
                        animation: 'gridScroll 2s linear infinite',
                        zIndex: 0,
                        mixBlendMode: 'hard-light',
                        backdropFilter: 'blur(4px)',
                        WebkitBackdropFilter: 'blur(4px)'
                      }} />
                      <MdOutlineSpaceDashboard 
                        size={20} 
                        style={{ 
                          position: 'relative', 
                          zIndex: 1,
                          animation: 'iconPulse 2.0s ease-in-out infinite'
                        }} 
                      />
                    </button>
                  </div>
                )}

                {/* Mobile Profile Card Layer */}
                {showProfileCard && (
                  <div style={{
                    position: 'absolute',
                    top: '-2px', 
                    left: '-2px', 
                    right: '-2px', 
                    bottom: '-2px',
                    zIndex: 20,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(46, 46, 46, 0.85)',
                    backdropFilter: 'blur(14px)',
                    WebkitBackdropFilter: 'blur(14px)',
                    borderRadius: '24px',
                    padding: '15px',
                    boxSizing: 'border-box',
                    overflowY: 'auto'
                  }}>
                    {/* Back Button */}
                    <button 
                      onClick={handleCloseProfileCard}
                      style={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        background: 'none',
                        border: 'none',
                        color: '#aaa',
                        fontSize: '0.9rem',
                        fontFamily: 'avenir-lt-pro, sans-serif',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        padding: '5px 10px'
                      }}
                    >
                      ← Back
                    </button>

                    {/* Profile Content */}
                    <div style={{
                      width: '100%',
                      maxWidth: '240px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: 'auto 0'
                    }}>
                      {!authUser ? (
                        // Logged Out View
                        <>
                          <div style={{
                            width: '70px',
                            height: '70px',
                            borderRadius: '50%',
                            border: '3px solid #88b7ff',
                            overflow: 'hidden',
                            marginBottom: '15px'
                          }}>
                            <img 
                              src={DefaultAvatarIcon} 
                              alt="Default Avatar" 
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          </div>
                          <p style={{
                            color: '#aaa',
                            fontFamily: 'avenir-lt-pro, sans-serif',
                            fontSize: '0.8rem',
                            textAlign: 'center',
                            margin: '0 0 20px 0'
                          }}>
                            You are not logged in
                          </p>
                        </>
                      ) : (
                        // Logged In View
                        <>
                          <input 
                            id="avatar-upload-mobile"
                            type="file" 
                            accept="image/*" 
                            style={{ display: 'none' }} 
                            onChange={handleAvatarChange} 
                          />
                          
                          <label 
                            htmlFor="avatar-upload-mobile"
                            style={{
                              width: '70px',
                              height: '70px',
                              borderRadius: '50%',
                              border: '2px solid #88b7ff',
                              overflow: 'hidden',
                              marginBottom: avatarPreview ? '8px' : '15px',
                              cursor: 'pointer',
                              display: 'block'
                            }}
                          >
                            <img 
                              src={getAvatarUrl()} 
                              alt="Profile" 
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          </label>

                          {avatarPreview && (
                            <div style={{
                              display: 'flex',
                              gap: '8px',
                              marginBottom: '12px'
                            }}>
                              <button 
                                onClick={handleSaveAvatar}
                                disabled={isSavingAvatar}
                                style={{
                                  padding: '5px 14px',
                                  backgroundColor: '#88B7FF',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '20px',
                                  fontFamily: 'avenir-lt-pro, sans-serif',
                                  fontSize: '0.75rem',
                                  cursor: 'pointer',
                                  opacity: isSavingAvatar ? 0.6 : 1
                                }}
                              >
                                {isSavingAvatar ? 'Saving...' : 'Save'}
                              </button>
                              <button 
                                onClick={handleCancelAvatar}
                                style={{
                                  padding: '5px 14px',
                                  backgroundColor: 'transparent',
                                  color: '#aaa',
                                  border: '1px solid #aaa',
                                  borderRadius: '20px',
                                  fontFamily: 'avenir-lt-pro, sans-serif',
                                  fontSize: '0.75rem',
                                  cursor: 'pointer'
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          )}

                                                  {/* Display Name with Edit */}
                        <div style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px',
                          marginBottom: '10px'
                        }}>
                          {isEditingName ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', alignItems: 'center' }}>
                              <input
                                type="text"
                                value={tempUserName}
                                onChange={(e) => setTempUserName(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '6px 10px',
                                  backgroundColor: '#444',
                                  color: 'white',
                                  border: '1px solid #88b7ff',
                                  borderRadius: '6px',
                                  fontFamily: 'avenir-lt-pro, sans-serif',
                                  fontSize: '0.85rem',
                                  outline: 'none',
                                  boxSizing: 'border-box'
                                }}
                              />
                              <div style={{ display: 'flex', gap: '8px' }}>
                                <button
                                  onClick={handleSaveProfileToFirebase}
                                  style={{
                                    padding: '6px 16px',
                                    backgroundColor: '#88B7FF',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontFamily: 'avenir-lt-pro, sans-serif',
                                    fontSize: '0.8rem',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Save
                                </button>
                                <button
                                  onClick={() => {
                                    setIsEditingName(false);
                                    setTempUserName(userName);
                                  }}
                                  style={{
                                    padding: '6px 16px',
                                    backgroundColor: 'transparent',
                                    color: '#aaa',
                                    border: '1px solid #aaa',
                                    borderRadius: '6px',
                                    fontFamily: 'avenir-lt-pro, sans-serif',
                                    fontSize: '0.8rem',
                                    cursor: 'pointer'
                                  }}
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <p style={{
                                color: '#fff',
                                fontFamily: 'avenir-lt-pro, sans-serif',
                                fontSize: '1rem',
                                margin: 0,
                                fontWeight: 500
                              }}>
                                {getDisplayName()}
                              </p>
                              <button
                                onClick={() => {
                                  setIsEditingName(true);
                                  setTempUserName(userName);
                                }}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  color: 'white',
                                  cursor: 'pointer',
                                  padding: '2px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  transition: 'color 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#88b7ff'}
                                onMouseLeave={(e) => e.currentTarget.style.color = 'white'}
                              >
                                <LuPencilLine size={16} />
                              </button>
                            </>
                          )}
                        </div>

                          <p style={{
                            color: '#aaa',
                            fontFamily: 'avenir-lt-pro, sans-serif',
                            fontSize: '0.75rem',
                            margin: '0 0 12px 0'
                          }}>
                            {authUser?.email}
                          </p>

                                                  {/* ========== CURRENT PLAN (signed in only) ========== */}
              {authUser && (
                <div style={{
                  width: '70%',
                  maxWidth: '260px',
                  background: 'none',
                  padding: '10px 14px',
                  borderRadius: '12px',
                  color: 'white',
                  fontFamily: 'avenir-lt-pro, sans-serif',
                  fontSize: '0.8rem',
                  textAlign: 'center',
                  
                  marginTop: '-20px',
                  marginBottom: '10px',
                  flexShrink: 0
                }}>
                  <span style={{ color: '#aaa', marginRight: '6px' }}>Current Plan:</span>
                  <span style={{ color: '#ffffffff', fontWeight: '600' }}>
                    {userData?.subscription?.planName || userData?.pendingPlan?.name || 'Starter'}
                  </span>
                  {(userData?.subscription?.billingCycle || userData?.pendingPlan?.billingCycle) && (
  <span style={{ color: '#aaa', fontSize: '0.7rem', marginLeft: '6px' }}>
    ({userData?.subscription?.billingCycle || userData?.pendingPlan?.billingCycle})
  </span>
)}
                </div>
              )}
            

                          <button 
                            onClick={() => setShowEmailChangePopup(true)}
                            style={{
                              width: '100%',
                              padding: '8px',
                              backgroundColor: '#444',
                              color: 'white',
                              border: 'none',
                              borderRadius: '8px',
                              fontFamily: 'avenir-lt-pro, sans-serif',
                              fontSize: '0.85rem',
                              cursor: 'pointer',
                              marginBottom: '8px'
                            }}
                          >
                            Change Email
                          </button>
                          <button 
                            onClick={() => setShowPasswordChangePopup(true)}
                            style={{
                              width: '100%',
                              padding: '8px',
                              backgroundColor: '#444',
                              color: 'white',
                              border: 'none',
                              borderRadius: '8px',
                              fontFamily: 'avenir-lt-pro, sans-serif',
                              fontSize: '0.85rem',
                              cursor: 'pointer',
                              marginBottom: '8px'
                            }}
                          >
                            Change Password
                          </button>
                          <button 
                            onClick={() => setShowDeleteDisclaimer(true)}
                            style={{
                              width: '100%',
                              padding: '8px',
                              backgroundColor: '#444',
                              color: '#ffffffff',
                              
                              borderRadius: '8px',
                              fontFamily: 'avenir-lt-pro, sans-serif',
                              fontSize: '0.85rem',
                              cursor: 'pointer',
                              marginBottom: '12px'
                            }}
                          >
                            Delete Account
                          </button>

                          {/* Sign Out Button */}
                          <button 
                            onClick={handleSignOut}
                            style={{
                              width: '50%',
                              padding: '8px',
                              backgroundColor: 'transparent',
                              color: '#ff6b6b',
                              border: '1px solid #ff6b6b',
                              borderRadius: '8px',
                              fontFamily: 'avenir-lt-pro, sans-serif',
                              fontSize: '0.85rem',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#ff6b6b';
                              e.currentTarget.style.color = 'white';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent';
                              e.currentTarget.style.color = '#ff6b6b';
                            }}
                          >
                            Sign Out
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
              
              {/* User greeting text moved outside video container for mobile */}
              <div style={{
                position: 'absolute',
                bottom: '-30px',
                left: '0',
                right: '0',
                textAlign: 'center',
                color: 'white',
                fontFamily: 'avenir-lt-pro, sans-serif',
                fontSize: '0.8rem',
                fontWeight: 400,
                paddingBottom: '5px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}>
                <span style={{
                  width: '5px',
                  height: '5px',
                  borderRadius: '50%',
                  backgroundColor: authUser ? '#6bf41cff' : '#ff6b6b',
                  display: 'inline-block',
                  flexShrink: 0
                }}></span>
                {authUser ? `Hi ${getDisplayName()}, Welcome` : 'You are not logged in'}
              </div>
            </div>

            {/* Mobile Typewriter Text */}
            <div style={{
              position: 'absolute',
              top: `calc(50% - min(40vh, 235px) * ${mobileScale})`,
              left: '45%',
              transform: `translateX(-50%) scale(${mobileScale})`,
              width: `min(72vw, 300px)`,
              zIndex: 11,
              color: 'white',
              fontFamily: 'avenir-lt-pro, sans-serif',
              fontSize: `clamp(1.4rem, 5vw, 1.6rem)`,
              fontWeight: 500,
              letterSpacing: '-0.5px',
              textAlign: 'right',
              whiteSpace: 'nowrap',
              minHeight: '80px',
              lineHeight: '1.2',
              padding: '0 8px',
              boxSizing: 'border-box',
              transformOrigin: 'center top',
              transition: 'transform 0.3s ease-out, opacity 0.3s ease',
              opacity: (showMobileMainContent && !showA2HSOverlay && !showProfileCard) ? 1 : 0,
              pointerEvents: 'none',
            }}>
              <span style={{whiteSpace: 'pre', display: 'inline'}}>
                {typedText}
                <span style={{ 
                  opacity: showCursor ? 1 : 0,
                  animation: 'blink 1s infinite',
                  display: 'inline',
                  marginLeft: '1px'
                }}>█</span>
              </span>
            </div>

            {/* Right Swipe Indicator - Updated text */}
            <div style={{
              position: 'absolute',
              right: '20px',
              top: '50%',
              transform: `translateY(-50%) scale(${mobileScale})`,
              zIndex: 10,
              opacity: (isBottomRevealed || isRightRevealed || showA2HSOverlay) ? 0 : 1,
              transition: 'opacity 0.3s ease-out, transform 0.3s ease-out',
              transformOrigin: 'right center'
            }}>
              <div style={{
                position: 'absolute',
                right: '-0px',
                marginTop: '-170px',
                top: '50%',
                writingMode: 'vertical-rl',
                transform: 'translateY(-50%)',
                color: 'white',
                fontSize: '0.85rem',
                whiteSpace: 'nowrap',
                animation: 'blink 2s ease-in-out infinite, floatVertical 3s ease-in-out infinite',
                height: '100px',
                textAlign: 'center'
              }}>
                Swipe left for Menu
              </div>

              <div style={{
                position: 'absolute',
                right: '-7px',
                top: '50%',
                transform: 'translateY(-50%)',
                animation: 'floatHorizontal 3s ease-in-out infinite'
              }}>
                <img 
                  src={LeftSwipe} 
                  alt="Swipe left"
                  style={{
                    width: '20px',
                    height: 'auto'
                  }}
                />
              </div>
            </div>

            {/* Bottom Swipe Indicator - Updated text */}
            <div style={{
              position: 'absolute',
              bottom: '15px',
              left: '68%',
              transform: `translateX(-50%) scale(${mobileScale})`,
              zIndex: 10,
              animation: (isBottomRevealed || isRightRevealed || showA2HSOverlay) ? 'none' : 'floatVertical 3s ease-in-out infinite',
              opacity: (isBottomRevealed || isRightRevealed || showA2HSOverlay) ? 0 : 1,
              transition: 'opacity 0.3s ease-out, transform 0.3s ease-out',
              transformOrigin: 'center bottom',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <div style={{
                color: 'white',
                fontSize: '0.7rem',
                marginBottom: '10px',
                animation: 'blink 2s ease-in-out infinite'
              }}>
                Swipe up for Login
              </div>
              <img 
                src={UpSwipe} 
                alt="Swipe up"
                style={{
                  width: '20px',
                  height: 'auto'
                }}
              />
            </div>
          </div>

                                                  {/* Bottom Reveal Container */}
                    <div style={{
            position: 'fixed',
            bottom: isBottomRevealed ? 0 : '-100vh',
            left: 0,
            width: '100%',
            height: isMobile ? 'calc(var(--vh, 1vh) * 100 * 0.85)' : '80%',
            backgroundColor: '#2e2e2e',
            zIndex: 20,
            transition: 'bottom 0.3s ease-out',
            padding: authUser ? '50px 20px 15px 20px' : '80px 20px 15px 20px',
            paddingBottom: `calc(15px + env(safe-area-inset-bottom, 0px))`,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            overflow: 'hidden',
            visibility: (isBottomRevealed && window.innerHeight > 400) ? 'visible' : 'hidden'
          }}>
             {/* Close button */}
            <div 
              style={{
                position: 'absolute',
                top: 'var(--safe-top)',
                right: '25px',
                fontSize: '2.3rem',
                color: 'white',
                cursor: 'pointer',
                zIndex: 21
              }}
              onClick={closeReveals}
            >
              ×
            </div>

            {/* ========== SETTINGS HINT TEXT (signed in only) ========== */}
            {authUser && (
              <div style={{
                color: '#919191ff',
                fontSize: '0.75rem',
                textAlign: 'center',
                fontFamily: 'avenir-lt-pro, sans-serif',
                marginBottom: '15px',
                marginTop: '5px',
                flexShrink: 0,
                animation: 'blink 2s ease-in-out infinite'
              }}>
                Tap Profile for Account Settings
              </div>
            )}

            {/* ========== TOP SEPARATOR ========== */}
            <div style={{
              width: '100%',
              height: '1px',
              backgroundColor: 'white',
              margin: '0 0 0 0',
              flexShrink: 0
            }} />

              {/* ========== TOP SPACER ========== */}
            <div style={{ height: authUser ? '90px' : '60px', flexShrink: 0 }} />
           
            {/* ========== PROFILE AVATAR + WELCOME TEXT ========== */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flexShrink: 0,
              marginTop: authUser ? '-20px' : '20px',
              marginBottom: authUser ? '30px' : '15px'
            }}>
              <button 
                onClick={authUser ? openProfileFromMobileMenu : undefined}
                style={{
                  width: authUser ? '135px' : '120px',
                  height: authUser ? '135px' : '120px',
                  borderRadius: '50%',
                  padding: '0px',
                  backgroundColor: '#595959',
                  boxSizing: 'border-box',
                  overflow: 'hidden',
                  border: '2px solid #ffffffff',
                  cursor: authUser ? 'pointer' : 'default',
                  animation: authUser ? 'profilePulse 1.5s ease-in-out infinite' : 'none',
                  transition: 'transform 0.2s ease',
                  outline: 'none'
                }}
                onMouseEnter={(e) => {
                  if (authUser) {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.borderColor = '#ffffff';
                  }
                }}
                onMouseLeave={(e) => {
                  if (authUser) {
                    e.currentTarget.style.transform = '';
                    e.currentTarget.style.borderColor = '#88b7ff';
                  }
                }}
              >
                <img 
                  src={getAvatarUrl()} 
                  alt="User"
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              </button>
              <div style={{
                color: 'white',
                fontSize: '1.2rem',
                textAlign: 'center',
                lineHeight: '1.4',
                marginTop: authUser ? '20px' : '12px'
              }}>
                Welcome<br />{authUser ? getDisplayName() : 'Guest'}
              </div>
              {/* ========== CURRENT PLAN (signed in only) ========== */}
              {authUser && (
                <div style={{
                  width: '100%',
                  maxWidth: '260px',
                  background: '#383838ff',
                  padding: '10px 14px',
                  borderRadius: '12px',
                  color: 'white',
                  fontFamily: 'avenir-lt-pro, sans-serif',
                  fontSize: '0.8rem',
                  textAlign: 'center',
                  marginTop: '10px',
                  flexShrink: 0
                }}>
                  <span style={{ color: '#aaa', marginRight: '6px' }}>Current Plan:</span>
                  <span style={{ color: '#ffffffff', fontWeight: '600' }}>
                    {userData?.subscription?.planName || userData?.pendingPlan?.name || 'Starter'}
                  </span>
                  {(userData?.subscription?.billingCycle || userData?.pendingPlan?.billingCycle) && (
                    <span style={{ color: '#aaa', fontSize: '0.7rem', marginLeft: '6px' }}>
                      ({userData?.subscription?.billingCycle || userData?.pendingPlan?.billingCycle})
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* ========== BUTTONS ========== */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              width: '100%',
              maxWidth: '300px',
              margin: authUser ? '15px 0 100px 0' : '15px 0 45px 0',
              alignItems: 'center',
              flexShrink: 0
            }}>
              {!authUser ? (
                <>
                  <button 
                    className="signup-btn"
                    onClick={() => handleAuthClick('signup')}
                    style={{
                      backgroundColor: 'white',
                      color: '#2e2e2e',
                      border: 'none',
                      padding: '12px 30px',
                      fontSize: '1.1rem',
                      fontFamily: 'avenir-lt-pro, sans-serif',
                      fontWeight: 500,
                      borderRadius: '30px',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s ease',
                      width: '100%'
                    }}
                  >
                    Sign Up
                  </button>
                  <button 
                    className="login-btn"
                    onClick={() => handleAuthClick('login')}
                    style={{
                      backgroundColor: 'white',
                      color: '#2e2e2e',
                      border: 'none',
                      padding: '12px 30px',
                      fontSize: '1.1rem',
                      fontFamily: 'avenir-lt-pro, sans-serif',
                      fontWeight: 500,
                      borderRadius: '30px',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s ease',
                      width: '100%'
                    }}
                  >
                    Log In
                  </button>
                </>
              ) : (
                <button 
                  className="signup-btn"
                  onClick={handleSignOut}
                  style={{
                    backgroundColor: 'white',
                    color: '#2e2e2e',
                    border: 'none',
                    padding: '12px 30px',
                    fontSize: '1.1rem',
                    fontFamily: 'avenir-lt-pro, sans-serif',
                    fontWeight: 500,
                    borderRadius: '30px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    width: '100%'
                  }}
                >
                  Sign Out
                </button>
              )}
            </div>
 {/* ========== BOTTOM SPACER ========== */}
            <div style={{ flex: 1, minHeight: '10px', flexShrink: 0 }} />
                        {/* ========== BOTTOM SEPARATOR ========== */}
            <div style={{
              width: '100%',
              height: '1px',
              backgroundColor: 'white',
              margin: authUser ? '-30px 0 20px 0' : '0 0 20px 0',
              flexShrink: 0
            }} />

            {/* ========== TERMS & COPYRIGHT ========== */}
            <div style={{
              color: 'white',
              fontSize: '0.75rem',
              textAlign: 'center',
              maxWidth: '300px',
              lineHeight: '1.3',
              paddingBottom: '35px',
              flexShrink: 0
            }}>
              {!authUser ? (
                <>
                  By continuing, you agree to our<br />
                  <a 
                    href="/terms" 
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.opener) {
                        window.opener.location.href = '/terms';
                        window.close();
                      } else {
                        navigate('/terms');
                      }
                    }}
                    style={{ color: 'white', textDecoration: 'underline' }}
                  >
                    Terms of Service
                  </a> and{' '}
                  <a 
                    href="/privacy" 
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.opener) {
                        window.opener.location.href = '/privacy';
                        window.close();
                      } else {
                        navigate('/privacy');
                      }
                    }}
                    style={{ color: 'white', textDecoration: 'underline' }}
                  >
                    Privacy Policy
                  </a>.
                </>
              ) : (
                <>
                  <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', marginBottom: '10px' }}>
                    <a 
                      href="/terms" 
                      onClick={(e) => {
                        e.preventDefault();
                        if (window.opener) {
                          window.opener.location.href = '/terms';
                          window.close();
                        } else {
                          navigate('/terms');
                        }
                      }}
                      style={{ color: 'white', textDecoration: 'underline' }}
                    >
                      Terms of Service
                    </a>
                    <a 
                      href="/privacy" 
                      onClick={(e) => {
                        e.preventDefault();
                        if (window.opener) {
                          window.opener.location.href = '/privacy';
                          window.close();
                        } else {
                          navigate('/privacy');
                        }
                      }}
                      style={{ color: 'white', textDecoration: 'underline' }}
                    >
                      Privacy Policy
                    </a>
                  </div>
                  <div style={{ color: '#ffffffff', fontSize: '0.7rem' }}>
                    © 2026 Outlne, All Rights Reserved
                  </div>
                </>
              )}
            </div>
          </div>

           {/* Right Reveal Container */}
          <div style={{
            position: 'fixed',
            top: 0,
            right: isRightRevealed ? 0 : '-80%',
            width: '80%',
            height: '100%',
            backgroundColor: '#2e2e2e',
            zIndex: 20,
            transition: 'right 0.3s ease-out',
            padding: '20px',
            paddingTop: 'var(--safe-top)',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column'
          }}>
            {/* Close button */}
            <div 
              style={{
                position: 'absolute',
                top: 'var(--safe-top-small)',
                right: '20px',
                fontSize: '2.0rem',
                color: 'white',
                cursor: 'pointer',
                zIndex: 21
              }}
              onClick={closeReveals}
            >
              ×
            </div>

            {/* Menu title above top separator */}
            <div style={{
              color: 'white',
              fontSize: '1.7rem',
              textAlign: 'center',
              fontFamily: 'avenir-lt-pro, sans-serif',
              fontWeight: '500',
              paddingTop: '3px',
              marginBottom: '30px',
              marginTop: '0px'
            }}>
              Menu
            </div>

            {/* Top separator */}
            <div style={{
              width: '100%',
              height: '1px',
              backgroundColor: 'white',
              margin: '0 0 15px 0',
              opacity: 1,
              visibility: 'visible'
            }} />

            {/* Navigation Menu */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              margin: '15px 0'
            }}>
              {updatedMenuItems.map((item, index) => (
                <div
                  key={index}
                  className="menu-item"
                  style={{
                    color: item.disabled ? '#777' : 'white',
                    fontFamily: 'avenir-lt-pro, sans-serif',
                    backgroundColor: item.disabled ? '#3d3d3d' : '#4d4d4d',
                    fontWeight: '500',
                    borderRadius: '6px',
                    padding: '9px',
                    fontSize: '1rem',
                    textAlign: 'center',
                    cursor: item.disabled ? 'default' : 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => handleMenuNavigation(item.path, item.disabled)}
                >
                  {item.name}
                </div>
              ))}
            </div>

            {/* Middle separator */}
            <div style={{
              width: '100%',
              height: '1px',
              backgroundColor: 'white',
              margin: '15px 0',
              opacity: 1,
              visibility: 'visible'
            }} />

            {/* Input section */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              margin: '10px 0',
              minHeight: '0px'
            }}>
              <div style={{
                color: 'white',
                fontSize: '1rem',
                textAlign: 'center',
                fontFamily: 'avenir-lt-pro, sans-serif',
                fontWeight: '500'
              }}>
                Ready to Start?
              </div>
              
              {/* Input container with inline button */}
              <div style={{ 
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transform: 'scale(0.85)',
                transformOrigin: 'center',
                width: '117%',
                marginLeft: '-8.5%'
              }}>
                <input
                  type="text"
                  placeholder={subtextOptions[currentSubtext]}
                  className="animated-input"
                  style={{
                    backgroundColor: '#3f3f3f',
                    color: 'white',
                    padding: '10px 12px',
                    border: showError ? '1px solid #ff6b6b' : 'none',
                    borderRadius: '8px',
                    fontFamily: 'monospace',
                    fontSize: '16px',
                    textAlign: 'left',
                    outline: 'none',
                    flexGrow: 1,
                    minWidth: '0',
                    boxSizing: 'border-box',
                    lineHeight: '1.2'
                  }}
                  ref={inputRef}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                    setShowError(false);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleGenerateClick();
                    }
                  }}
                />
                
                <button 
                  className="generate-btn"
                  onClick={handleGenerateClick}
                  style={{
                    backgroundColor: '#ffffffff',
                    color: 'black',
                    border: 'none',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    fontFamily: 'avenir-lt-pro, sans-serif',
                    fontWeight: '500',
                    fontSize: '0.85rem',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Go
                </button>
              </div>
              
              {/* Error message */}
              {showError && (
                <div style={{
                  color: '#ff6b6b',
                  fontSize: '0.75rem',
                  textAlign: 'center',
                  fontFamily: 'avenir-lt-pro, sans-serif',
                  marginTop: '-8px'
                }}>
                  This field is required
                </div>
              )}
            </div>

            {/* Footer navigation */}
            <div style={{
              marginTop: 'auto',
              paddingBottom: '0px'
            }}>
              {/* First stack: Blog, Careers, Press, Partnerships - NOW TWO COLUMN LAYOUT */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '1px 10px',
                marginBottom: '25px'
              }}>
                {['Blog', 'Press', 'Careers', 'Acknowledgements', 'Partnerships'].map((item) => (
                  <a
                    key={item}
                    href={`/${item.toLowerCase().replace(' ', '-')}`}
                    className="footer-link"
                    style={{
                      color: 'white',
                      fontSize: '0.8rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease',
                      lineHeight: '1.2'
                    }}
                  >
                    {item}
                  </a>
                ))}
              </div>

              {/* Second stack: Terms, Privacy - STAYS SAME (one column) */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1px',
                marginBottom: '15px'
              }}>
                {[
                  { text: "Terms of Service", path: "/terms" },
                  { text: "Privacy Policy", path: "/privacy" }
                ].map((item) => (
                  <a
                    key={item.path}
                    href={item.path}
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.opener) {
                        window.opener.location.href = item.path;
                        window.close();
                      } else {
                        navigate(item.path);
                      }
                    }}
                    className="footer-link"
                    style={{
                      color: 'white',
                      fontSize: '0.8rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease',
                      lineHeight: '1.2'
                    }}
                  >
                    {item.text}
                  </a>
                ))}
              </div>

              {/* Copyright and social icons - STAYS SAME */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderTop: '1px solid #555',
                paddingTop: '12px'
              }}>
                <div style={{
                  color: '#ffffffff',
                  fontSize: '0.7rem'
                }}>
                  © 2026 Outlne, All Rights Reserved
                </div>

                <div style={{
                  display: 'flex',
                  gap: '12px'
                }}>
                  <a href="https://instagram.com/tryoutlne" style={{ display: 'flex', alignItems: 'center' }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.40-1.439-1.40z"/>
                    </svg>
                  </a>
                  <a href="https://tiktok.com/@outlne" style={{ display: 'flex', alignItems: 'center' }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                      <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 10.692 6.33 6.33 0 0 0 10.857-4.424V8.687a8.182 8.182 0 0 0 4.773 1.527V7.057a4.831 4.831 0 0 1-1.003-.371z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* NEW: Light-Mode Popups */}
      {/* Email Change Popup */}
      {showEmailChangePopup && (
        <div style={popupOverlayStyle} onClick={() => setShowEmailChangePopup(false)}>
          <div style={popupContentStyle} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ color: '#333', marginBottom: '20px', fontFamily: 'avenir-lt-pro, sans-serif' }}>Change Email</h3>
            <form onSubmit={handleChangeEmail}>
              <input 
                type="email" 
                placeholder="New Email" 
                value={newEmail} 
                onChange={(e) => setNewEmail(e.target.value)} 
                required 
                style={popupInputStyle} 
              />
              <input 
                type="password" 
                placeholder="Current Password" 
                value={emailPassword} 
                onChange={(e) => setEmailPassword(e.target.value)} 
                required 
                style={popupInputStyle} 
              />
              {emailError && <p style={{ color: '#E53935', fontSize: '0.85rem', margin: '-5px 0 10px 0' }}>{emailError}</p>}
              {emailSuccess && <p style={{ color: '#4CAF50', fontSize: '0.85rem', margin: '-5px 0 10px 0' }}>{emailSuccess}</p>}
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button type="button" onClick={() => setShowEmailChangePopup(false)} style={popupCancelStyle}>Cancel</button>
                <button type="submit" style={popupConfirmStyle}>Update</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Password Change Popup */}
      {showPasswordChangePopup && (
        <div style={popupOverlayStyle} onClick={() => setShowPasswordChangePopup(false)}>
          <div style={popupContentStyle} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ color: '#333', marginBottom: '20px', fontFamily: 'avenir-lt-pro, sans-serif' }}>Change Password</h3>
            <form onSubmit={handleChangePassword}>
              <input 
                type="password" 
                placeholder="Current Password" 
                value={oldPassword} 
                onChange={(e) => setOldPassword(e.target.value)} 
                required 
                style={popupInputStyle} 
              />
              <input 
                type="password" 
                placeholder="New Password (min 6 characters)" 
                value={newPassword} 
                onChange={(e) => setNewPassword(e.target.value)} 
                required 
                style={popupInputStyle} 
              />
              <input 
                type="password" 
                placeholder="Confirm New Password" 
                value={confirmNewPassword} 
                onChange={(e) => setConfirmNewPassword(e.target.value)} 
                required 
                style={popupInputStyle} 
              />
              {passwordError && <p style={{ color: '#E53935', fontSize: '0.85rem', margin: '-5px 0 10px 0' }}>{passwordError}</p>}
              {passwordSuccess && <p style={{ color: '#4CAF50', fontSize: '0.85rem', margin: '-5px 0 10px 0' }}>{passwordSuccess}</p>}
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button type="button" onClick={() => setShowPasswordChangePopup(false)} style={popupCancelStyle}>Cancel</button>
                <button type="submit" style={popupConfirmStyle}>Update</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Disclaimer Popup */}
      {showDeleteDisclaimer && (
        <div style={popupOverlayStyle} onClick={() => setShowDeleteDisclaimer(false)}>
          <div style={popupContentStyle} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ color: '#333', marginBottom: '20px', fontFamily: 'avenir-lt-pro, sans-serif' }}>Delete Account</h3>
            <p style={{ color: '#666', marginBottom: '25px', fontFamily: 'avenir-lt-pro, sans-serif' }}>
              Account deletion is not yet available. Please contact support for assistance.
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowDeleteDisclaimer(false)} style={popupConfirmStyle}>OK</button>
            </div>
          </div>
        </div>
      )}

      {/* Color Hover Styles */}
      <style>
        {`
          /* Prevent layout shift during typewriter animation */
          [style*="white-space: pre-line"] {
            line-height: 1.2;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          
          /* New hover styles */
          .signup-btn:hover {
            background-color: #3f3f3fff !important;
            color: #fff !important;
          }
          .login-btn:hover {
            background-color: #5a99ffff !important;
            color: #fff !important;
          }
          .subtext:hover {
            color: rgba(87, 87, 87, 1) !important;
          }

          /* Menu item hover effect */
          .menu-item:not([style*="color: #777"]):hover {
            background-color: #3a3a3a !important;
            transform: translateY(-1px);
          }

          /* Generate button hover */
          .generate-btn:hover {
            background-color: #4a85e0 !important;
            color: #fff !important;
          }

          /* Footer link hover */
          .footer-link:hover {
            color: #40a3ff !important;
          }

          /* Input animation */
          .animated-input::placeholder {
            transition: opacity 0.5s ease;
          }

          .animated-input:focus::placeholder {
            opacity: 0.5;
          }
        `}
      </style>

      {/* Animation Styles */}
      <style>
        {`
          :root {
            --vh: 1vh;
          }

          .a2hs-arrow {
            transition: opacity 0.3s ease, transform 0.3s ease;
          }
           @keyframes profilePulse {
            0%, 100% { 
              transform: scale(1);
            }
            50% { 
              transform: scale(1);
            }
          }

           @keyframes gridScroll {
            0% {
              background-position: 0px 0px;
            }
            100% {
              background-position: 12px 0px;
            }
          }

                   @keyframes iconPulse {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.15);
            }
          }
                            @keyframes pulseBorder {
            0%, 100% { 
              border-color: #b5b5b5ff;
              box-shadow: 0 0 0 0 rgba(136, 183, 255, 0.4);
              transform: scale(1);
            }
            50% { 
              border-color: #ffffffff;
              box-shadow: 0 0 0px 2px rgba(107, 174, 255, 0.55);
              transform: scale(1.02);
            }
          }

          @keyframes fadeInArrow {
            0% {
              opacity: 0;
              transform: translateY(-50%) scale(0.8);
            }
            100% {
              opacity: 1;
              transform: translateY(-50%) scale(1);
            }
          }
          
          .a2hs-overlay-closing .a2hs-arrow {
            animation: fadeOutArrow 0.3s ease-out forwards;
          }
          
          @keyframes fadeOutArrow {
            0% {
              opacity: 1;
              transform: translateY(-50%) scale(1);
            }
            100% {
              opacity: 0;
              transform: translateY(-50%) scale(0.8);
            }
          }

          @keyframes fadeInOverlay {
            0% {
              opacity: 0;
            }
            70% {
              opacity: 0.9;
            }
            100% {
              opacity: 1;
            }
          }

          @keyframes fadeOutOverlay {
            0% {
              opacity: 1;
            }
            30% {
              opacity: 0.7;
            }
            100% {
              opacity: 0;
            }
          }
          
          @keyframes openJaws {
            0% {
              max-height: 0;
              opacity: 0;
              transform: scale(0.7) translateY(-20px);
              width: 60%;
            }
            20% {
              max-height: 100px;
              opacity: 0.3;
              transform: scale(0.75) translateY(-15px);
              width: 70%;
            }
            40% {
              max-height: 200px;
              opacity: 0.5;
              transform: scale(0.8) translateY(-10px);
              width: 80%;
            }
            60% {
              max-height: 300px;
              opacity: 0.7;
              transform: scale(0.85) translateY(-5px);
              width: 90%;
            }
            80% {
              max-height: 400px;
              opacity: 0.9;
              transform: scale(0.88) translateY(-2px);
              width: 95%;
            }
            100% {
              max-height: none;
              opacity: 1;
              transform: scale(0.9) translateY(0);
              width: 100%;
            }
          }

          @keyframes closeJaws {
            0% {
              max-height: 500px;
              opacity: 1;
              transform: scale(0.9) translateY(0);
              width: 100%;
            }
            25% {
              max-height: 400px;
              opacity: 0.8;
              transform: scale(0.88) translateY(5px);
              width: 95%;
            }
            50% {
              max-height: 250px;
              opacity: 0.6;
              transform: scale(0.85) translateY(10px);
              width: 90%;
            }
            75% {
              max-height: 100px;
              opacity: 0.3;
              transform: scale(0.8) translateY(15px);
              width: 80%;
            }
            100% {
              max-height: 0;
              opacity: 0;
              transform: scale(0.7) translateY(20px);
              width: 60%;
            }
          }

          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            33% {
              opacity: 0.3;
            }
            66% {
              opacity: 0.7;
            }
            100% {
              opacity: 1;
            }
          }

          @keyframes fadeOut {
            0% {
              opacity: 1;
            }
            33% {
              opacity: 0.7;
            }
            66% {
              opacity: 0.3;
            }
            100% {
              opacity: 0;
            }
          }
          
          @keyframes shimmer {
            0% {
              transform: translateX(-100%);
            }
            100% {
              transform: translateX(200%);
            }
          }
          
          @keyframes pulse {
            0%, 100% { opacity: 0.6; }
            50% { opacity: 1; }
          }
          
          @keyframes floatHorizontal {
            0%, 100% { transform: translateX(0); }
            50% { transform: translateX(-10px); }
          }
          
          @keyframes floatVertical {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          
          @keyframes blink {
            0%, 100% { opacity: 0.7; }
            50% { opacity: 0.2; }
          }
          
          html, body {
            margin: 0;
            padding: 0;
            min-height: 100%;
            overflow-x: hidden;
            touch-action: none;
          }
          
          body {
            overflow-y: ${isMobile ? 'hidden' : 'auto'};
          }
        `}
      </style>
    </>
  );
}